<template>
  <div class="park-display-screen">
    <div class="portrait-of-enterprises-bg-img-out-box">
      <div class="portrait-of-enterprises-bg-img-box" v-if="pageModel === '2D'">
        <!--<img :src="parkDisplayScreenBottomBasicBigMap" class="portrait-of-enterprises-bg-img" alt="">-->
        <img src="../../../assets/park_bg/gjzz.jpg" class="portrait-of-enterprises-bg-img" alt v-if="yqCode === 'gjzz'">
        <img src="../../../assets/park_bg/demo.jpg" class="portrait-of-enterprises-bg-img" alt v-else-if="yqCode === 'demo'">
        <img src="../../../assets/park_bg/jxgj1.jpg" class="portrait-of-enterprises-bg-img" alt v-else-if="yqCode === 'jxgj'">
        <img src="../../../assets/park_bg/jxgj1.jpg" class="portrait-of-enterprises-bg-img" alt v-else>
        <!--<scene-model />-->
      </div>
    </div>

    <div class="park-display-screen-svg-box">
      <div class="park-display-screen-top">
        <div class="park-display-screen-top-time">{{ currentTime }} {{ currentLunarCalendarDate }}</div>
        <div class="park-display-screen-top-model" v-if="yqCode === 'jxgj'">
          <el-radio-group v-model="pageModel" size="mini" fill="#319FF6">
            <el-radio-button label="2D"></el-radio-button>
            <el-radio-button label="3D"></el-radio-button>
          </el-radio-group>
        </div>
<!--        <div class="park-display-screen-top-nav-left park-display-screen-top-nav-left-position"></div>-->
        <div class="park-display-screen-top-nav-left-position"></div>
        <div :class="['park-display-screen-top-nav-left-relative', currentNav === '1' ? 'park-display-screen-top-nav-left-current' : 'park-display-screen-top-nav-left']" @click="changeNav('1')">园区总览</div>
        <div :class="[currentNav === '2' ? 'park-display-screen-top-nav-left-current' : 'park-display-screen-top-nav-left']" @click="changeNav('2')">企业培育</div>
        <div class="park-display-screen-top-enterprise-name">{{yqName}}</div>
        <div :class="[currentNav === '3' ? 'park-display-screen-top-nav-current' : 'park-display-screen-top-nav']" @click="changeNav('3')">园区服务</div>
        <div :class="['park-display-screen-top-nav-relative', currentNav === '4' ? 'park-display-screen-top-nav-current' : 'park-display-screen-top-nav']" @click="() => {this.changeNav('4');this.changeNav2('4-1')}">物联感知</div>
        <div class="park-display-screen-top-nav-position"></div>
      </div>

      <div class="park-display-screen-svg-box-main">
        <div :class="[fullScreen ? 'portrait-of-enterprises-bg-3d-iframe-box2' : 'portrait-of-enterprises-bg-3d-iframe-box']" v-if="yqCode === 'jxgj' && pageModel === '3D'">
          <iframe scrolling="no" class="portrait-of-enterprises-bg-3d-iframe" frameBorder="0" allowTransparency="true" src="http://3d.damaiiot.com/build/#/"></iframe>
          <img src="../../../assets/upper/full_screen.png" alt="" title="全屏" class="portrait-of-enterprises-bg-3d-iframe-img" v-if="!fullScreen" @click="fullScreen = true">
          <img src="../../../assets/upper/full_screen_retract.png" alt="" title="收起" class="portrait-of-enterprises-bg-3d-iframe-img" v-if="fullScreen" @click="fullScreen = false">
        </div>


        <!-- 左 -->
        <div class="portrait-of-enterprises-left">
          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeftBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '1'">
              <div class="portrait-of-enterprises-left-nav">
                <img src="../../../assets/upper/page_left_shadow.png" class="portrait-of-enterprises-left-nav-img" alt="">
                <div class="portrait-of-enterprises-left-item" v-for="item in parkOverviewData" v-if="currentNav === '1'">
                  <div class="portrait-of-enterprises-left-item-line">
                    <div class="portrait-of-enterprises-left-item-line-top">
                      <div class="portrait-of-enterprises-left-item-line-tip">{{ item.name }}</div>
                      <img src="../../../assets/upper/page_left_tip.png" class="portrait-of-enterprises-left-item-line-left-img" alt>
                    </div>
                    <div class="portrait-of-enterprises-left-item-line-info">
                      <div class="clock">
                        <div :class="['digital', numItem > -1 ? `digital_${numItem}` : 'digital_point']" v-for="numItem in (item.num.toString())">
                          <span class="c1"></span>
                          <span class="c2"></span>
                          <span class="c3"></span>
                          <span class="l1"></span>
                          <span class="l2"></span>
                          <span class="r1"></span>
                          <span class="r2"></span>
                          <span class="point"></span>
                        </div>
                      </div>
                      <div class="portrait-of-enterprises-left-item-line-info-unit">{{item.unit}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-left-card" v-if="currentNav === '1'">
                <el-carousel indicator-position="outside" :interval="6000" style="width: 1.375rem;margin: 0.22rem auto 0;" height="0.775rem">
                  <el-carousel-item v-for="item in parkImgList" :key="item">
                    <img :src="item" alt class="portrait-of-enterprises-left-card-img">
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </transition>

          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeftBig" :duration="{enter:1000,leave:500}">
            <div class="animate__fadeInLeftBig portrait-of-enterprises-right-strip" v-show="currentNav === '2'">
              <div class="portrait-of-enterprises-left-nav2">
                <img src="../../../assets/upper/page_left_shadow.png" class="portrait-of-enterprises-left-nav-img" alt="">
                <div class="portrait-of-enterprises-left-item" v-for="item in enterpriseCultivationData" v-if="currentNav === '2'">
                  <div class="portrait-of-enterprises-left-item-line">
                    <div class="portrait-of-enterprises-left-item-line-top">
                      <div class="portrait-of-enterprises-left-item-line-tip">{{ item.name }}</div>
                      <img src="../../../assets/upper/page_left_tip.png" class="portrait-of-enterprises-left-item-line-left-img" alt>
                    </div>
                    <div class="portrait-of-enterprises-left-item-line-info">
                      <div class="clock">
                        <div :class="['digital', numItem > -1 ? `digital_${numItem}` : 'digital_point']" v-for="numItem in (item.num.toString())">
                          <span class="c1"></span>
                          <span class="c2"></span>
                          <span class="c3"></span>
                          <span class="l1"></span>
                          <span class="l2"></span>
                          <span class="r1"></span>
                          <span class="r2"></span>
                          <span class="point"></span>
                        </div>
                      </div>
                      <div class="portrait-of-enterprises-left-item-line-info-unit">{{item.unit}}</div>
                    </div>
                  </div>
                </div>
              </div>
<!--              <div class="portrait-of-enterprises-left-card"></div>-->
            </div>
          </transition>

          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeftBig" :duration="{enter:1000,leave:500}">
            <div class="animate__fadeInLeftBig portrait-of-enterprises-right-strip" v-show="currentNav === '3'">
              <div class="portrait-of-enterprises-left-nav2">
                <img src="../../../assets/upper/page_left_shadow.png" class="portrait-of-enterprises-left-nav-img" alt="">
                <div class="portrait-of-enterprises-left-item" v-for="item in parkServicesData" v-if="currentNav === '3'">
                  <div class="portrait-of-enterprises-left-item-line">
                    <div class="portrait-of-enterprises-left-item-line-top">
                      <div class="portrait-of-enterprises-left-item-line-tip">{{ item.name }}</div>
                      <img src="../../../assets/upper/page_left_tip.png" class="portrait-of-enterprises-left-item-line-left-img" alt>
                    </div>
                    <div class="portrait-of-enterprises-left-item-line-info">
                      <div class="clock">
                        <div :class="['digital', numItem > -1 ? `digital_${numItem}` : 'digital_point']" v-for="numItem in (item.num.toString())">
                          <span class="c1"></span>
                          <span class="c2"></span>
                          <span class="c3"></span>
                          <span class="l1"></span>
                          <span class="l2"></span>
                          <span class="r1"></span>
                          <span class="r2"></span>
                          <span class="point"></span>
                        </div>
                      </div>
                      <div class="portrait-of-enterprises-left-item-line-info-unit">{{item.unit}}</div>
                    </div>
                  </div>
                </div>
              </div>
<!--              <div class="portrait-of-enterprises-left-card"></div>-->
            </div>
          </transition>

          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeftBig" :duration="{enter:1000,leave:500}">
            <div class="animate__fadeInLeftBig portrait-of-enterprises-right-strip" v-show="currentNav === '4'">
              <div class="portrait-of-enterprises-left-nav3">
<!--                <img src="../../../assets/upper/page_left_shadow.png" class="portrait-of-enterprises-left-nav-img" alt="">-->
                <div class="portrait-of-enterprises-left-item" v-for="item in iotPerceptionData" v-if="currentNav === '4'" @click="changeNav2(item.nav)">
                  <div :class="[currentNav2 === item.nav ? 'portrait-of-enterprises-left-item-line-current' : 'portrait-of-enterprises-left-item-line']">
                    <div class="portrait-of-enterprises-left-item-line-left-img-out-box">
                      <img :src="item.img" :class="`portrait-of-enterprises-left-item-line-left-img-${item.nav}`" alt>
                    </div>
                    <div class="portrait-of-enterprises-left-item-line-tip">{{ item.name }}</div>
<!--                    <img src="../../../assets/upper/page_left_3_nav_embellish.png" class="portrait-of-enterprises-left-item-line-embellish" alt="">-->
                  </div>
                </div>
              </div>
<!--              <div class="portrait-of-enterprises-left-card"></div>-->
            </div>
          </transition>
        </div>

<!--        <div class="portrait-of-enterprises-center-top" v-if="currentNav2 === '4-5'"></div>-->
        <div class="portrait-of-enterprises-center-top">
          <img src="../../../assets/upper/page_center_top_shadow.png" alt="" class="portrait-of-enterprises-center-top-shadow">
          <div class="portrait-of-enterprises-center-top-left-decorate"></div>
          <div class="portrait-of-enterprises-center-top-decorate-tip">今日概况</div>
          <div class="portrait-of-enterprises-center-top-right-decorate"></div>
          <div class="portrait-of-enterprises-center-top-data-statistics-item" v-for="item in pageTopData">
            <div class="portrait-of-enterprises-center-top-data-statistics-item-name">{{item.name}}</div>
            <div class="portrait-of-enterprises-center-top-data-statistics-item-num">
              <div class="portrait-of-enterprises-center-top-data-statistics-item-num-info">{{item.num}}</div>
              <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-box" v-if="item.dynamic">
                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-1"></div>
                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-2"></div>
                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-3"></div>
              </div>
            </div>
          </div>
        </div>

        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line" v-show="currentNav === '1'">
            <img src="../../../assets/upper/page_center_bottom_shadow.png" class="portrait-of-enterprises-center-bottom-line-top-img" alt="">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page1BottomData">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line" v-show="currentNav === '2'" v-if="yqCode !== 'gjzz'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page2BottomData">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line2" v-show="currentNav === '3'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page3BottomData">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line" v-show="currentNav === '4' && currentNav2 === '4-1'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page4BottomData_1">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line3" v-show="currentNav === '4' && currentNav2 === '4-2'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page4BottomData_2">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line" v-show="currentNav === '4' && currentNav2 === '4-3'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page4BottomData_3">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line" v-show="currentNav === '4' && currentNav2 === '4-4'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page4BottomData_4">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line3" v-show="currentNav === '4' && currentNav2 === '4-5'">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page4BottomData_5">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>

        <!-- 中间数据 -->
<!--        <div class="portrait-of-enterprises-center">-->


          <!--          <div class="portrait-of-enterprises-left-item-device-config" v-if="currentNav2 === '4-1'">-->
          <!--            <div class="portrait-of-enterprises-left-item-device-config-fold-btn" @click="deviceManageBoxShowState = !deviceManageBoxShowState">展开收起</div>-->
          <!--            <transition name="el-zoom-in-top">-->
          <!--              <div class="portrait-of-enterprises-left-item-device-config-main" v-show="deviceManageBoxShowState">-->
          <!--                <div class="portrait-of-enterprises-left-item-device-config-main-item" v-for="item in deviceManageList">-->
          <!--                  <el-radio v-model="devicePageChoose" :label="item.type" size="samll">{{ item.deviceName }}</el-radio>-->
          <!--                  <i class="el-icon-damai-shezhi" @click="showDeviceConfig(item)"></i>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </transition>-->
          <!--          </div>-->

<!--        </div>-->

        <!-- 右 -->
        <div class="portrait-of-enterprises-right">
          <!-- 园区概况 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '1'">
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近五年产值和税收</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="outputValueChart" height="100%" :titleShow="false" :xAxis="outputValueChartXAxis" :yAxis="outputValueChartYAxis" :legendData="outputValueChartLegendData" :series="outputValueChartSeries" v-if="currentNav === '1'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">园区产业分布</span>
                </div>
                <div class="portrait-of-enterprises-item-ring-box">
                  <div class="portrait-of-enterprises-item-ring-box-left">
                    <upper-ring upperRingId="enterpriseDistributionRing" height="100%" :colorList="enterpriseDistributionColorList" :ringLegend="enterpriseDistributionLegend" :series="enterpriseDistributionConfig" v-if="currentNav === '1'"/>
                  </div>
                  <div class="portrait-of-enterprises-item-ring-box-right" id="portraitEnterprisesItemRing">
                    <div class="portrait-of-enterprises-item-ring-box-right-line" v-for="item in enterpriseDistributionData">
                      <div class="portrait-of-enterprises-item-ring-box-right-line-color" :style="{'background': item.color}"></div>
                      <div class="portrait-of-enterprises-item-ring-box-right-line-name">{{item.name}}</div>
                      <div class="portrait-of-enterprises-item-ring-box-right-line-num">{{item.num}}</div>
                      <div class="portrait-of-enterprises-item-ring-box-right-line-proportion">({{item.proportion}})</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">园区荣誉</span>
                </div>
                <div style="flex: 1;overflow: hidden;padding: 0.02rem 0.05rem" id="parkHonorTimer">
                  <el-timeline>
                    <el-timeline-item v-for="(activity, index) in parkHonorData" :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size" :timestamp="activity.content">{{activity.timestamp}}</el-timeline-item>
                  </el-timeline>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">明星企业</span>
                </div>
                <dv-scroll-board :config="famousEnterpriseConfig" class="famous-enterprise-dv-scroll-board" v-if="currentNav === '1'" />
              </div>
            </div>
          </transition>

          <!-- 企业培育 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '2'">
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近五年入驻企业数</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="fiveYearsEnterprisesChart" height="100%" :titleShow="false" :xAxis="fiveYearsEnterprisesChartXAxis" :yAxis="fiveYearsEnterprisesChartYAxis" :series="fiveYearsEnterprisesChartSeries" v-if="currentNav === '2'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">企业类别统计</span>
                </div>
                <div style="flex: 1;">
                  <upper-stacking-bar barIdName="enterpriseCategoryChart" height="100%" :titleShow="false" :tooltipShow="false" :xAxis="enterpriseCategoryChartXAxis" :yAxis="enterpriseCategoryChartYAxis" :series="enterpriseCategoryChartSeries" v-if="currentNav === '2'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">知识产权总数</span>
                </div>
                <div style="flex: 1;overflow-y: auto;display: flex;justify-content: center;flex-direction: column;" id="totalIntellectualProperty">
                  <div class="total-intellectual-property-config-line" v-for="item in totalIntellectualPropertyConfig">
                    <div class="total-intellectual-property-config-line-name" :title="item.name">{{item.name}}</div>
                    <div class="total-intellectual-property-config-line-value">
                      <div class="total-intellectual-property-config-line-value-info" :style="{width: item.width}">{{item.num}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">企业知识产权</span>
                </div>
                <dv-scroll-board :config="businessRevenueConfig" style="flex: 1;"/>
              </div>
            </div>
          </transition>

          <!-- 园区服务 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '3'">
              <div class="portrait-of-enterprises-item2">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">物业工单统计</span>
                </div>
                <div class="portrait-of-enterprises-item-property-work-order-line">
                  <div class="portrait-of-enterprises-item-property-work-order-line-item" v-for="item in propertyWorkOrderTopData">
                    <div class="portrait-of-enterprises-item-property-work-order-line-item-title">{{item.name}}</div>
                    <div class="portrait-of-enterprises-item-property-work-order-line-item-num">{{item.num}}</div>
                  </div>
                </div>
                <div style="flex: 1;">
                  <upper-stacking-bar barIdName="propertyWorkOrderChart" height="100%" :titleShow="false" :tooltipShow="false" :xAxis="propertyWorkOrderChartXAxis" :yAxis="propertyWorkOrderChartYAxis" :series="propertyWorkOrderChartSeries" v-if="currentNav === '3'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">资产巡检情况</span>
                </div>
                <div class="portrait-of-enterprises-item-liquid-fill-top-line">
                  <div class="portrait-of-enterprises-item-liquid-fill-top-line-item" v-for="item in inspectionTopData">
                    <div class="portrait-of-enterprises-item-liquid-fill-top-line-item-tip">{{ item.name }}</div>
                    <div class="portrait-of-enterprises-item-liquid-fill-top-line-item-num">{{ item.value }}</div>
                  </div>
                </div>
                <div class="portrait-of-enterprises-item-liquid-fill-line">
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="finishOnTimeLiquidFill" :series="finishOnTimeSeries" v-if="currentNav === '3'"/>
                    <div>按时完成率</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="kuangXunLiquidFill" :series="kuangXunSeries" v-if="currentNav === '3'"/>
                    <div>旷巡率</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="missedInspectionLiquidFill" :series="missedInspectionSeries" v-if="currentNav === '3'"/>
                    <div>漏巡率</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="breakdownLiquidFill" :series="breakdownSeries" v-if="currentNav === '3'"/>
                    <div>故障率</div>
                  </div>
                  <!--                  <upper-stacking-bar barIdName="fiveYearsEnterprisesChart" height="100%" :titleShow="false" :xAxis="fiveYearsEnterprisesChartXAxis" :yAxis="fiveYearsEnterprisesChartYAxis" :series="fiveYearsEnterprisesChartSeries" v-if="currentNav === '3'" />-->
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">电子开票情况</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="invoiceChart" height="100%" :titleShow="false" :xAxis="invoiceChartXAxis" :yAxis="invoiceChartYAxis" :series="invoiceChartSeries" v-if="currentNav === '3'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">严选服务使用情况</span>
                </div>
                <div style="flex: 1;display: flex;justify-content: space-between;flex-direction: column;">
<!--                  <dv-capsule-chart :config="valueAddedDataConfig" style="height:100%"/>-->
                  <div class="total-intellectual-property-config-line" v-for="item in valueAddedDataConfig.data">
                    <div class="total-intellectual-property-config-line-name" :title="item.name">{{item.name}}</div>
                    <div class="total-intellectual-property-config-line-value">
                      <div class="total-intellectual-property-config-line-value-info" :style="{width: item.width}">{{item.value}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- 物联感知——设备管理 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav2 === '4-1'">
              <div class="portrait-of-enterprises-item-device-top">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">设备运行总览</span>
                </div>
                <div class="portrait-of-enterprises-item-equipment-operation-box">
                  <div class="portrait-of-enterprises-item-equipment-operation-ring-box">
                    <upper-ring upperRingId="equipmentOperationStatusRing" height="100%" :colorList="equipmentOperationStatusColorList" :ringLegend="equipmentOperationStatusLegend" :series="equipmentOperationStatusConfig" v-if="currentNav2 === '4-1'"/>
                  </div>
                  <div class="portrait-of-enterprises-item-equipment-operation-status-box">
                    <div class="portrait-of-enterprises-item-equipment-operation-status-box-item" v-for="deviceNum in deviceNumData">
                      <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-name">{{ deviceNum.name }}</div>
                      <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-num">
                        <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-num-info">{{ deviceNum.num }}</div>
                        <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-unit">台</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-device-type">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">设备运行概况</span>
                </div>
                <div class="portrait-of-enterprises-item-device-statistics-table">
                  <div class="portrait-of-enterprises-item-device-statistics-table-line" v-for="device in deviceStatisticsList">
                    <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line">
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line-left">{{device.deviceName}}</div>
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line-right">
                        在线设备(台)：<span class="portrait-of-enterprises-item-device-statistics-table-line-name-line-right-info">{{device.online}}</span>
                      </div>
                    </div>
                    <div class="portrait-of-enterprises-item-device-statistics-table-line-info">
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-info-left" :style="{width: device.onlineWidth}">{{device.onlineWidth}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- 物联感知——人行管理 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav2 === '4-2'">
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">人员出入记录</span>
                </div>
                <dv-scroll-board :config="personnelAccessRecordConfig" style="flex: 1;"/>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">门禁出入流量</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="accessControlChart" height="100%" :titleShow="false" :xAxis="accessControlChartXAxis" :yAxis="accessControlChartYAxis" :series="accessControlChartSeries" v-if="currentNav2 === '4-2'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">梯控出入流量</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="ladderControlChart" height="100%" :titleShow="false" :xAxis="ladderControlChartXAxis" :yAxis="ladderControlChartYAxis" :series="ladderControlChartSeries" v-if="currentNav2 === '4-2'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">访客情况</span>
                </div>
                <div style="flex: 1;">
                  <upper-stacking-bar barIdName="visitorChart" height="100%" :titleShow="false" :tooltipShow="false" :xAxis="visitorChartXAxis" :yAxis="visitorChartYAxis" :series="visitorChartSeries" v-if="currentNav2 === '4-2'"/>
                </div>
              </div>
            </div>
          </transition>

          <!-- 物联感知——车行管理 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav2 === '4-3'">
              <div class="portrait-of-enterprises-item-car-1">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">进出抓拍</span>
                </div>
                <div class="portrait-of-enterprises-right-in-and-out-snapshot">
                  <div class="portrait-of-enterprises-right-in-and-out-snapshot-item" v-if="carInData.carAccessTime">
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-top-title">进场抓拍</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-img-out-box">
                      <img :src="carInData.carPicSnapUrl" alt class="portrait-of-enterprises-right-in-and-out-snapshot-item-img">
                    </div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip"><b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>{{ carInData.parkingTypeText }}</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip"><b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>{{ carInData.deviceName }}</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip"><b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>{{ carInData.carAccessTime }}</div>
                  </div>
                  <div class="portrait-of-enterprises-right-in-and-out-snapshot-item" v-if="carOutData.carAccessTime">
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-top-title">出场抓拍</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-img-out-box">
                      <img :src="carOutData.carPicSnapUrl" alt class="portrait-of-enterprises-right-in-and-out-snapshot-item-img">
                    </div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip"><b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>{{ carOutData.parkingTypeText }}</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip"><b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>{{ carOutData.deviceName }}</div>
                    <div class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip">
                      <b class="portrait-of-enterprises-right-in-and-out-snapshot-item-spot"></b>
                      <span class="portrait-of-enterprises-right-in-and-out-snapshot-item-tip-text">{{ carOutData.carAccessTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-car-2" >
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近七天车流量统计</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="trafficVolumeChart" height="100%" :titleShow="false" :xAxis="trafficVolumeChartXAxis" :yAxis="trafficVolumeChartYAxis" :series="trafficVolumeChartSeries" v-if="currentNav2 === '4-3'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-car-3">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近七天收费统计</span>
                </div>
                <div class="portrait-of-enterprises-item-car-top-line">
                  <div class="portrait-of-enterprises-item-car-top-line-item" v-for="item in todayParkingTopData">
                    <div class="portrait-of-enterprises-item-car-top-line-item-title">{{item.name}}</div>
                    <div class="portrait-of-enterprises-item-car-top-line-item-num">{{item.num}}</div>
                  </div>
                </div>
                <div style="flex: 1;">
                  <upper-stacking-bar barIdName="parkingChargeChart" height="100%" :titleShow="false" :xAxis="parkingChargeChartXAxis" :yAxis="parkingChargeChartYAxis" :series="parkingChargeChartSeries" v-if="currentNav2 === '4-3'"/>
                </div>
              </div>
            </div>
          </transition>

          <!-- 物联感知——能耗管理 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav2 === '4-4'">
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">当月能耗分布情况</span>
                </div>
                <div class="portrait-of-enterprises-item-energy-distribution-box">
                  <div class="portrait-of-enterprises-item-energy-distribution-ring-box">
                    <upper-ring upperRingId="electricityMonthRing" height="100%" :ringLegend="electricityMonthLegend" :colorList="energyColorList" :series="electricityMonthConfig" v-if="currentNav2 === '4-4'"/>
                  </div>
                  <div class="portrait-of-enterprises-item-energy-distribution-ring-box">
                    <upper-ring upperRingId="waterMonthRing" height="100%" :ringLegend="waterMonthLegend" :colorList="energyColorList" :series="waterMonthConfig" v-if="currentNav2 === '4-4'"/>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近半年用电量情况</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="halfYearElectricityChart" height="100%" :titleShow="false" :colorList="energyColorList" :xAxis="halfYearElectricityChartXAxis" :yAxis="halfYearElectricityChartYAxis" :series="halfYearElectricityChartSeries" v-if="currentNav2 === '4-4'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">近半年用水情况</span>
                </div>
                <div style="flex: 1;">
                  <upper-line lineId="halfYearTariffChart" height="100%" :titleShow="false" :colorList="energyColorList" :xAxis="halfYearWaterChartXAxis" :yAxis="halfYearWaterChartYAxis" :series="halfYearWaterChartSeries" v-if="currentNav2 === '4-4'"/>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">能耗企业排行</span>
                </div>
                <div style="flex: 1;">
                  <div class="portrait-of-enterprises-item-energy-ranking-line" v-for="(item, index) in enterpriseEnergyConsumptionConfigData">
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-1" v-if="index === 0">01</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-2" v-if="index === 1">02</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-3" v-if="index === 2">03</div>

                    <div class="portrait-of-enterprises-item-energy-ranking-line-info">
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-name">{{item.name}}</div>
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric">
                        <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric-info" :style="{width: item.electricWidth}">{{item.electricValue}}度</div>
                      </div>
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-water">
                        <div class="portrait-of-enterprises-item-energy-ranking-line-info-water-info" :style="{width: item.waterWidth}">{{item.waterValue}}吨</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- 物联感知——消防管理 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" v-show="currentNav2 === '4-5'">
              <div class="portrait-of-enterprises-item-car-1">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">消防设备运行总览</span>
                </div>
                <div class="portrait-of-enterprises-item-equipment-operation-box">
                  <div class="portrait-of-enterprises-item-equipment-operation-ring-box">
                    <upper-ring upperRingId="equipmentOperationStatusRing" height="100%" :colorList="fireControlEquipmentOperationStatusColorList" :ringLegend="fireControlEquipmentOperationStatusLegend" :series="fireControlEquipmentOperationStatusConfig" v-if="currentNav2 === '4-5'"/>
                  </div>
                  <div class="portrait-of-enterprises-item-equipment-operation-status-box">
                    <div class="portrait-of-enterprises-item-equipment-operation-status-box-item" v-for="deviceNum in fireControlDeviceNumData">
                      <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-name">{{ deviceNum.name }}</div>
                      <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-num">
                        <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-num-info">{{ deviceNum.num }}</div>
                        <div class="portrait-of-enterprises-item-equipment-operation-status-box-item-unit">台</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-car-2">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">今日报警</span>
                </div>
                <dv-scroll-board :config="callThePoliceTodayRecordConfig" style="flex: 1;"/>
              </div>
              <div class="portrait-of-enterprises-item-car-3">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">本月消防报警分布排行</span>
                </div>
                <div style="flex: 1;">
                  <div class="portrait-of-enterprises-item-energy-ranking-line" v-for="(item, index) in fireControlConsumptionConfigData">
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-1" v-if="index === 0">01</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-2" v-if="index === 1">02</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-3" v-if="index === 2">03</div>

                    <div class="portrait-of-enterprises-item-energy-ranking-line-info">
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-name">{{item.deviceName}}{{item.alarmType||''}}</div>
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric">
                        <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric-info" :style="{width: item.alarmWidth}">{{item.alarmCount}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <el-dialog
      class="device-manage-config-dialog-visible animate__animated animate__fadeInDown"
      title="设备点位配置"
      :visible.sync="deviceManageConfigDialogVisible"
      width="70%"
    >
      <dv-border-box-12 v-if="deviceManageConfigDialogVisible">
        <div class="device-manage-config-dialog-visible-main">
          <div class="device-manage-config-dialog-visible-left">
            <img
              src="../../../assets/park_bg/jxgj1.jpg"
              class="device-manage-config-dialog-visible-left-img"
              alt
            >
            <!--            <vue-fabric ref="canvas" class="device-manage-config-dialog-visible-left-canvas"></vue-fabric>-->
          </div>
          <div class="device-manage-config-dialog-visible-right"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deviceManageConfigDialogVisible = false" size="small">取 消</el-button>
          <el-button
            type="primary"
            @click="deviceManageConfigDialogVisible = false"
            size="small"
          >确 定</el-button>
        </span>
      </dv-border-box-12>
    </el-dialog>
  </div>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import Radar from "../../../components/Echarts/Radar/Radar";
import CommonMultiline from "../../../components/Echarts/Multiline/CommonMultiline";
import CommonLineAndBar from "../../../components/Echarts/Multiline/CommonLineAndBar";
import BasicInfo from "../../../components/Basic/BasicInfo/basicInfo";
import CustomizedPie from "../../../components/Echarts/Pie/Pie/CustomizedPie";
import SceneModel from "../../../components/SceneModel/SceneModel";
import CommonMeter from "../../../components/Echarts/Meter/commonMeter";
import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";
import { api } from "../../api/BigDataScreen";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import UpperHorizontalBar from "../../../components/UpperEcharts/upperHorizontalBar";
import UpperStackingBar from "../../../components/UpperEcharts/upperStackingBar";
import { getLunarCalendarDate } from "../../../tool/tools";
import UpperRing from "../../../components/UpperEcharts/upperRing";
import UpperLine from "../../../components/UpperEcharts/upperLine";
import UpperLiquidFill from "../../../components/UpperEcharts/upperLiquidFill";
import { fabric } from "fabric";
import screenfull from "screenfull";

let parkHonorTollingTimer = null, portraitEnterprisesItemRingTollingTimer = null, totalIntellectualPropertyTollingTimer = null;

export default {
  components: {
    UpperLiquidFill,
    UpperLine,
    UpperRing,
    UpperStackingBar,
    UpperHorizontalBar,
    CommonRing,
    CommonMeter,
    SceneModel,
    CustomizedPie,
    BasicInfo,
    CommonLineAndBar,
    CommonMultiline,
    Radar
  },
  name: "park-display-screen",
  data() {
    return {
      yqName: "",
      yqCode: "",
      currentTime: "",
      currentLunarCalendarDate: "",
      pageModel: '',
      fullScreen: false,
      currentNav: "",
      currentNav2: "",

      parkDisplayScreenBottomBasicBigMap: require("../../../assets/park_img.png"),
      commonTitleStyle: {
        color: "#ffffff"
      },

      pageTopData: [
        {code: 'todayHumanTraffic', name: '人流', num: '0', dynamic: true },
        {code: 'todayCarTraffic', name: '车流', num: '0', dynamic: true },
        {code: 'totalDeviceNumber', name: '总设备', num: '0', dynamic: false },
        {code: 'enterpriseCount', name: '企业数量', num: '0', dynamic: false },
        {code: 'totalPersonNumber', name: '人员总量', num: '0', dynamic: false },
        // {code: 'offlineDeviceNumber', name: '设备异常', num: '0', dynamic: false },
        {code: 'authorizePersonNumber', name: '授权人数', num: '0', dynamic: false },
        {code: 'todayVisitorCount', name: '访客人数', num: '0', dynamic: false },
        {code: 'todayMessageSendCount', name: '消息数量', num: '0', dynamic: false },
      ],

      //  —————————————————————————————————————————园区总览页数据—————————————————————————————————————————————

      // 园区总览数据
      parkOverviewData: [
        {code: "jzmj", name: "总建筑面积", icon: "el-icon-damai-yuanqu1", num: 0, unit: '万平米'},
        {code: "ydmj", name: "占地面积", icon: "el-icon-damai-fangyuan", num: 0, unit: '亩'},
        {code: "ldsl", name: "楼栋数", icon: "el-icon-damai-dalou", num: 0, unit: '栋'},
        {code: "leaseArea", name: "招商面积", icon: "el-icon-damai-shangdian", num: 0, unit: '万平米'},
        {code: "occupancyRatio", name: "出租率", icon: "el-icon-damai-fangwuzujin", num: 0, unit: '%'}
      ],
      // 园区展示图
      parkImgList: [],
      // 园区总览底部数据
      page1BottomData: [
        {code: "annualOutput", name: "年总产值", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
        {code: "annualTax", name: "年总税收", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
        {code: "perAreaOutput", name: "年亩均产值", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
        {code: "perAreaTax", name: "年亩均税收", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"}
      ],

      // 产值税收
      outputValueChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      outputValueChartYAxis: {
        type: "value",
        name: "万元",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        splitLine: {
          show: false
        }
      },
      outputValueChartLegendData: ["产值", "税收"],
      outputValueChartSeries: [],

      // 园区产业分布
      enterpriseDistributionColorList: ['#12FDF0', '#E2F58B', '#F47153', '#0086FF', '#AC7AFF', '#FFD341', '#8BF59F', '#FF73B8', '#84ABFF', '#FFA7A7'],
      enterpriseDistributionLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        top: "center",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      enterpriseDistributionData: [],
      enterpriseDistributionConfig: [],

      // 明星企业
      famousEnterpriseConfig: {},

      // 园区荣誉
      parkHonorData: [],

      //  —————————————————————————————————————————企业培育页数据—————————————————————————————————————————————

      // 企业培育数据
      enterpriseCultivationData: [
        {code: "enterEnterpriseCount", name: "入驻企业数", icon: "el-icon-damai-qiye11", num: "0", unit: '个'},
        {code: "enterpriseTotalIncome", name: "企业总收入", icon: "el-icon-damai-qiyezongheshujuchaxun", num: "0", unit: '万元'},
        {code: "financingMoneyCount", name: "获得融资企业数", icon: "el-icon-damai-qiyejibenxinxichaxun", num: "0", unit: '个'},
        {code: "financingMoney", name: "融资总额", icon: "el-icon-damai-qiyetouzixinxichaxun", num: "0", unit: '万元'},
        {code: "parkTotalPatentCount", name: "企业知识产权数", icon: "el-icon-damai-zhishichanquan2", num: "0", unit: '个'}
      ],
      // 企业培育底部数据
      page2BottomData: [
        {code: "totalHatchCount", name: "累计孵化企业", icon: "el-icon-damai-shuishou", num: "0", unit: '家'},
        {code: "totalGradCount", name: "累计毕业企业", icon: "el-icon-damai-shuishou", num: "0", unit: '家'},
        {code: "curYearHatchCount", name: "当年新增入孵企业", icon: "el-icon-damai-shuishou", num: "0", unit: '家'},
        {code: "curYearGradCount", name: "当年新增毕业企业", icon: "el-icon-damai-shuishou", num: "0", unit: '家'}
      ],

      // 近五年入驻企业数
      fiveYearsEnterprisesChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      fiveYearsEnterprisesChartYAxis: [
        {
          type: "value",
          name: "个",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      fiveYearsEnterprisesChartSeries: [],

      // 企业类别统计
      enterpriseCategoryChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      enterpriseCategoryChartYAxis: {
        type: "value",
        name: "家",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        splitLine: {
          show: false
        }
      },
      enterpriseCategoryChartSeries: [],

      // 知识产权总数
      totalIntellectualPropertyConfig: [],

      // 企业营收
      businessRevenueConfig: {
        header: ["企业名称", "知识产权数"],
        columnWidth: [220, 80],
        waitTime: 5000,
        headerHeight: 24,
        headerBGC: "#ffffff00",
        oddRowBGC: "#ffffff00",
        evenRowBGC: "#122C4799",
        data: []
      },

      //  —————————————————————————————————————————园区服务页数据—————————————————————————————————————————————

      // 园区服务数据
      parkServicesData: [
        {code: "repairRecordCount", name: "处理工单数", icon: "el-icon-damai-jijiangdaoqi", num: "0", unit: '单'},
        {code: "inspectTaskCount", name: "已巡检任务数", icon: "el-icon-damai-xunjian", num: "0", unit: '个'},
        {code: "totalInvoiceCount", name: "电子开票次数", icon: "el-icon-damai-icon_huabanfuben", num: "0", unit: '次'},
        {code: "hqptPolicyViews", name: "惠企政策浏览量", icon: "el-icon-damai-basic", num: "0", unit: '次'},
        {code: "valueaddItemCount", name: "严选服务类目", icon: "el-icon-damai-zengzhifuwu", num: "0", unit: '项'}
      ],
      // 园区服务底部数据
      page3BottomData: [
        {code: "yqNoticeCount", name: "发布公告数", icon: "el-icon-damai-shuishou", num: "0", unit: '篇'},
        {code: "yqNewsCount", name: "发布资讯数", icon: "el-icon-damai-shuishou", num: "0", unit: '篇'},
        {code: "eventCount", name: "发布活动数", icon: "el-icon-damai-shuishou", num: "0", unit: '场'},
        {code: "serviceUserCount", name: "服务用户数", icon: "el-icon-damai-shuishou", num: "0", unit: '位'},
        {code: "messageSendCount", name: "消息推送数", icon: "el-icon-damai-shuishou", num: "0", unit: '条'}
      ],

      // 物业工单统计
      propertyWorkOrderChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      propertyWorkOrderChartYAxis: {
        type: "value",
        name: "单",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        splitLine: {
          show: false
        }
      },
      propertyWorkOrderChartSeries: [],
      propertyWorkOrderTopData: [
        {name: '工单总数', code: 'repairRecordCount', num: 0},
        {name: '处理率', code: 'repairRate', num: 0}
      ],

      // 资产巡检情况
      inspectionTopData: [
        { name: "巡检点数量", value: "0" },
        { name: "巡检任务", value: "0" },
        { name: "巡检班组", value: "0" },
        { name: "巡检人员", value: "0" }
      ],
      finishOnTimeSeries: [],
      kuangXunSeries: [],
      missedInspectionSeries: [],
      breakdownSeries: [],

      // 电子开票情况
      invoiceChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      invoiceChartYAxis: [
        {
          type: "value",
          name: "次",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      invoiceChartSeries: [],

      // 严选服务使用情况
      valueAddedDataConfig: {
        data: [],
        // colors: ['#fb1313', '#FB4E13', '#FB7F13', '#FBA813', '#FBD013'],
        showValue: true
      },

      //  —————————————————————————————————————————物联感知页数据—————————————————————————————————————————————
      // 物联感知数据
      iotPerceptionData: [
        {code: "totalConstructionArea", name: "设备管理", icon: "el-icon-damai-shebei2", num: "0", nav: "4-1", img: require('../../../assets/upper/page_4_1.png')},
        {code: "areaCovered", name: "人行管理", icon: "el-icon-damai-yonghu", num: "0", nav: "4-2" , img: require('../../../assets/upper/page_4_2.png')},
        {code: "buildingNumber", name: "车行管理", icon: "el-icon-damai-cheliang-", num: "0", nav: "4-3" , img: require('../../../assets/upper/page_4_3.png')},
        {code: "investmentArea", name: "能耗管理", icon: "el-icon-damai-nenghaoqushi", num: "0", nav: "4-4" , img: require('../../../assets/upper/page_4_4.png')},
        {code: "occupancyRate", name: "消防管理", icon: "el-icon-damai-xiaofang", num: "0", nav: "4-5" , img: require('../../../assets/upper/page_4_5.png')}
      ],
      // 物联感知底部数据-1
      page4BottomData_1: [
        {code: "totalDeviceCount", name: "物联设备总数", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "onlineRate", name: "设备在线率", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "offlineDeviceCount", name: "设备离线数", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "todayAlarmCount", name: "今日告警数", icon: "el-icon-damai-shuishou", num: "0"}
      ],
      // 物联感知底部数据-2
      page4BottomData_2: [
        {code: "todayHumanTraffic", name: "今日人流量（人次）", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "todayVisitor", name: "今日访客数", icon: "el-icon-damai-shuishou", num: "0"}
      ],
      // 物联感知底部数据-3
      page4BottomData_3: [
        {code: "parkingPlaceTotalNumber", name: "园区车位总数", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "parkingPlaceLeftNumber", name: "空余车位数", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "presentCarNumber", name: "在场车辆数", icon: "el-icon-damai-shuishou", num: "0"},
        {code: "parkingSaturability", name: "饱和度", icon: "el-icon-damai-shuishou", num: "0"}
      ],
      // 物联感知底部数据-4
      page4BottomData_4: [
        {code: "monthlyEletric", name: "当月用电量", icon: "el-icon-damai-shuishou", num: "0", unit: "万度"},
        {code: "monthlyEletricCost", name: "当月电费总额", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
        {code: "monthlyWater", name: "当月用水量", icon: "el-icon-damai-shuishou", num: "0", unit: "吨"},
        {code: "monthlyWaterCost", name: "当月水费总额", icon: "el-icon-damai-shuishou", num: "0", unit: "万元"}
      ],
      // 物联感知底部数据-5
      page4BottomData_5: [
        {code: 'monthAlarmRecordNumber', name: '本月报警数', num: '0'},
        {code: 'monthAlarmReleaseNumber', name: '本月消警数', num: '0'},
      ],

      // 设备运行状况
      equipmentOperationStatusColorList: ['#3ADBDD', '#193248'],
      equipmentOperationStatusLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      equipmentOperationStatusConfig: [],

      deviceManageBoxShowState: false,
      devicePageChoose: "video",
      deviceManageList: [
        { deviceName: "监控设备", type: "video" },
        { deviceName: "液位设备", type: "level" },
        { deviceName: "液压设备", type: "hydraulic" }
      ],

      currentDeviceChooseItem: {},
      currentDeviceNeverConfigList: [],
      currentDeviceAlreadyConfigList: [],
      deviceManageConfigDialogVisible: false,

      // 设备统计
      deviceNumData: [
        { name: "设备总数", type: "", num: 0 },
        { name: "正常在线", type: "success", num: 0 }
      ],
      deviceStatisticsList: [],

      // 人员进出情况
      personnelAccessRecordConfig: {
        header: ["姓名", "进出位置", "进出时间"],
        columnWidth: [120, 150, 120],
        align: ['left', 'left', 'left'],
        waitTime: 5000,
        headerHeight: 24,
        headerBGC: "#ffffff00",
        oddRowBGC: "#ffffff00",
        evenRowBGC: "#122C4799",
        data: []
      },

      // 门禁出入情况
      accessControlChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      accessControlChartYAxis: [
        {
          type: "value",
          name: "人次",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      accessControlChartSeries: [],

      // 梯控出入情况
      ladderControlChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      ladderControlChartYAxis: [
        {
          type: "value",
          name: "人次",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      ladderControlChartSeries: [],

      // 访客情况
      visitorChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      visitorChartYAxis: {
        type: "value",
        name: "人次",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        splitLine: {
          show: false
        }
      },
      visitorChartSeries: [],

      carInData: {},
      carOutData: {},

      todayParkingTopData: [
        {name: '今日实收金额：', code: 'todayReceivedMoney', num: 0},
        {name: '今日支付笔数：', code: 'todayPaidCount', num: 0}
      ],

      // 近七天车流量统计
      trafficVolumeChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      trafficVolumeChartYAxis: [
        {
          type: "value",
          name: "车次",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      trafficVolumeChartSeries: [],

      // 近七天停车收费统计
      parkingChargeChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      parkingChargeChartYAxis: [
        {
          type: "value",
          name: "元",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      parkingChargeChartSeries: [],

      energyColorList: ['#12FDF0', '#E2F58B', '#F47153'],

      // 当月用电情况
      electricityMonthLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      electricityMonthConfig: [],

      // 当月用水情况
      waterMonthLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        top: "center",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      waterMonthConfig: [],

      // 近半年用电量统计
      halfYearElectricityChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      halfYearElectricityChartYAxis: [
        {
          type: "value",
          name: "万度",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      halfYearElectricityChartSeries: [],

      // 近半年电费情况
      halfYearTariffChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      halfYearTariffChartYAxis: [
        {
          type: "value",
          name: "万元",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      halfYearTariffChartSeries: [],

      // 近半年用水量统计
      halfYearWaterChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      halfYearWaterChartYAxis: [
        {
          type: "value",
          name: "万吨",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      halfYearWaterChartSeries: [],

      // 企业能耗排行
      enterpriseEnergyConsumptionConfigData: [],

      // 消防设备运行状况
      fireControlEquipmentOperationStatusColorList: ['#3ADBDD', '#193248'],
      fireControlEquipmentOperationStatusLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      fireControlEquipmentOperationStatusConfig: [],
      // 设备统计
      fireControlDeviceNumData: [
        { name: "设备总数", num: 0 },
        { name: "正常在线", num: 0 }
      ],
      // 今日报警数
      callThePoliceTodayRecordConfig: {
        header: ["报警设备", "报警时间", "状态"],
        columnWidth: [120, 150, 120],
        align: ['left', 'left', 'left'],
        waitTime: 5000,
        headerHeight: 24,
        headerBGC: "#ffffff00",
        oddRowBGC: "#ffffff00",
        evenRowBGC: "#122C4799",
        data: []
      },
      // 消防排行
      fireControlConsumptionConfigData: [],

      // 设备总数
      totalNumber: "0",
      // 设备离线数
      offLineNumber: "0",
      // 消防设备类型
      fireControlDeviceList: [],

      // 设备在线率

      equipmentOnlineRateConfig: {
        value: 66,
        lineDash: [10, 2]
      },

      // 报警数
      totalAlarmNumber: "0",
      // 未消警数
      unDealNumber: "0",
      // 报警记录
      alarmRecordList: [],

      // 消防员列表
      firemanList: [],

      // 报警排名
      alarmRankingConfig: {},

      // 烟感点位信息
      smokePointsList: [
        {
          deviceName: "A座4层楼梯烟感传感器",
          code: "08061",
          x: "964px",
          y: "459px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08036",
          x: "454px",
          y: "279px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08038",
          x: "964px",
          y: "299px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08040",
          x: "654px",
          y: "329px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],
      // 温感点位信息
      temperaturePointsList: [
        {
          deviceName: "a",
          code: "a",
          x: "384px",
          y: "279px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "b",
          code: "b",
          x: "1094px",
          y: "329px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "c",
          code: "c",
          x: "1074px",
          y: "239px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],
      // 液位点位信息
      levelPointsList: [],
      // 液压点位信息
      hydraulicPointsList: [],
      // 手报点位信息
      handPointsList: [
        {
          deviceName: "A座20层20F手动报警按钮",
          code: "08129",
          x: "1034px",
          y: "429px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],

      hkVideoPlayerLink_smoke: "",
      hkVideoPlayerLink_temperature: "",
      hkVideoPlayerLink_hand: ""
    };
  },
  created() {
    this.yqCode = bus.global.yqCode
    if (this.yqCode === 'jxgj') {
      this.pageModel = '2D'
    } else {
      this.pageModel = '2D'
    }
    if (this.yqCode === 'gjzz') {
      this.pageTopData = [
        {code: 'todayHumanTraffic', name: '人流', num: '0', dynamic: true },
        {code: 'todayCarTraffic', name: '车流', num: '0', dynamic: true },
        {code: 'totalDeviceNumber', name: '总设备', num: '0', dynamic: false },
        {code: 'enterpriseCount', name: '企业数量', num: '0', dynamic: false },
        {code: 'totalPersonNumber', name: '人员总量', num: '0', dynamic: false },
        // {code: 'offlineDeviceNumber', name: '设备异常', num: '0', dynamic: false },
        {code: 'authorizePersonNumber', name: '授权人数', num: '0', dynamic: false },
        // {code: 'todayVisitorCount', name: '访客人数', num: '0', dynamic: false },
        {code: 'todayMessageSendCount', name: '消息数量', num: '0', dynamic: false },
      ]
    }
    this.getTime();
    this.getCurrentTime();
    this.getYqInfo();
  },
  mounted() {
    this.currentNav = '1'

    this.initWebSocket()
    this.parkHonorTolling()
    this.portraitEnterprisesItemRingTolling()
    this.totalIntellectualPropertyTolling()

    this.getSwingRecentRecord()
    this.getCarInRecentRecord()
    this.getCarOutRecentRecord()

    this.getFiveYearsEnterprisesCharData()
  },
  methods: {
    // 获取园区信息
    getYqInfo() {
      this.$axios.post(api.getYqInfo, {})
        .then(res => {
          let data = res.data.data;
          this.yqName = data.yqName
        })
        .catch(errorHandler("查询园区信息失败"));
    },

    // 获取历史刷卡记录
    getSwingRecentRecord() {
      this.$axios.post(api.getSwingRecentRecord, {
        pageSize: 5,
        pageNum: 1,
      })
        .then(res => {
          let data = res.data.data.list || [], personnelAccessRecordConfigData = []
          data.map(v => {
            if (v.openTime) {
              v.openTime = v.openTime.slice(11, 19)
            }
            let arr = [`<i style='color:#08C8B7' class='el-icon-damai-chengshijinglixianxing'></i>${v.personName}`, v.deviceName, v.openTime];
            personnelAccessRecordConfigData.push(arr)
            if (personnelAccessRecordConfigData.length > 5) {
              personnelAccessRecordConfigData.length = 5
            }
          })
          let personnelAccessRecordConfig = {
            header: ["姓名", "进出位置", "进出时间"],
            columnWidth: [120, 150, 120],
            align: ['left', 'left', 'left'],
            waitTime: 5000,
            headerHeight: 24,
            headerBGC: "#ffffff00",
            oddRowBGC: "#ffffff00",
            evenRowBGC: "#122C4799",
            data: personnelAccessRecordConfigData
          }
          this.personnelAccessRecordConfig = personnelAccessRecordConfig
        })
        .catch(errorHandler("查询数据失败"));
    },

    // 获取历史车辆进记录
    getCarInRecentRecord() {
      this.$axios.post(api.getCarRecentRecord, {
        pageSize: 1,
        pageNum: 1,
        carAccessType: '1'
      })
        .then(res => {
          let data = res.data.data.list || [];
          if (data.length > 0) {
            let carInData = data[0]
            if (carInData.parkingType === '1') {
              carInData.parkingTypeText = '包月车'
            } else if (carInData.parkingType === '2') {
              carInData.parkingTypeText = '临停车'
            } else if (carInData.parkingType === '3') {
              carInData.parkingTypeText = '白名单'
            } else if (carInData.parkingType === '4') {
              carInData.parkingTypeText = '白名单车'
            } else if (carInData.parkingType === '5') {
              carInData.parkingTypeText = '黑名单车'
            }
            this.carInData = carInData
          }
        })
        .catch(errorHandler("查询数据失败"));
    },

    // 获取历史车辆出记录
    getCarOutRecentRecord() {
      this.$axios.post(api.getCarRecentRecord, {
        pageSize: 1,
        pageNum: 1,
        carAccessType: '2'
      })
        .then(res => {
          let data = res.data.data.list || [];
          if (data.length > 0) {
            let carOutData = data[0]
            if (carOutData.parkingType === '1') {
              carOutData.parkingTypeText = '包月车'
            } else if (carOutData.parkingType === '2') {
              carOutData.parkingTypeText = '临停车'
            } else if (carOutData.parkingType === '3') {
              carOutData.parkingTypeText = '白名单'
            } else if (carOutData.parkingType === '4') {
              carOutData.parkingTypeText = '白名单车'
            } else if (carOutData.parkingType === '5') {
              carOutData.parkingTypeText = '黑名单车'
            }
            this.carInData = carOutData
          }
        })
        .catch(errorHandler("查询数据失败"));
    },

    // 获取园区基础数据
    getParkBaseInfo() {
      this.$axios.get(api.getParkBaseInfo, {})
        .then(res => {
          let data = res.data.data;
          this.parkOverviewData.map(v => {
            v.num = data[v.code] || 0;
          })
          this.parkImgList = data.ptssurlList || []
        })
        .catch(errorHandler("查询园区基础数据失败"));
    },
    // 获取顶部数据
    getStatisticData() {
      this.$axios.get(api.getStatisticData, {})
        .then(res => {
          let data = res.data.data;
          this.pageTopData.map(v => {
            if (v.code !== 'enterpriseCount') {
              v.num = data[v.code] || 0
            }
          })
          let enterpriseIndustryData = data.enterpriseIndustryData || {}, enterpriseDistributionData = [], enterpriseDistributionConfigData = [], allNumber = 0;
          for (let i in enterpriseIndustryData) {
            allNumber = allNumber + enterpriseIndustryData[i]
            let obj = {
              name: i,
              value: enterpriseIndustryData[i]
            };
            enterpriseDistributionConfigData.push(obj);
          }
          enterpriseDistributionConfigData.map((v, i) => {
            let legendDataObj = {
              name: v.name,
              num: v.value,
              color: this.enterpriseDistributionColorList[i],
              proportion: `${parseFloat(v.value / allNumber * 100).toFixed(2)}%`
            }
            enterpriseDistributionData.push(legendDataObj)
          })
          this.enterpriseDistributionData = enterpriseDistributionData
          this.enterpriseDistributionConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "85%"],
              data: enterpriseDistributionConfigData,
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    },
    // 获取园区荣誉
    getHonorPage() {
      this.$axios.get(api.getHonorPage, {})
        .then(res => {
          let data = res.data.data;
          let parkHonorData = [];
          data.map(v => {
            let obj = {
              content: v.xmmc,
              timestamp: v.hqsj,
              color: "#7AFDFE",
              size: "normal"
            };
            parkHonorData.push(obj);
          });
          this.parkHonorData = parkHonorData;
        })
        .catch(errorHandler("获取园区荣誉失败"));
    },
    // 获取明星企业
    getStartEnterprise () {
      this.$axios.get(api.getStartEnterprise, {})
        .then(res => {
          let data = res.data.data;
          let famousEnterpriseConfigData = [];
          data.map(v => {
            let arr = [`<i style='color:#08C8B7' class='el-icon-damai-qiye11'></i>${v.name}`, v.contractStartTime];
            famousEnterpriseConfigData.push(arr);
          });
          this.famousEnterpriseConfig = {
            header: ["企业名称", "入驻时间"],
            columnWidth: [200, 100],
            waitTime: 5000,
            headerHeight: 24,
            headerBGC: "#ffffff00",
            oddRowBGC: "#ffffff00",
            evenRowBGC: "#122C4799",
            data: famousEnterpriseConfigData
          }
        })
        .catch(errorHandler("获取明星企业失败"));
    },
    // 时间定时器
    getTime() {
      setInterval(() => {
        this.getCurrentTime();
      }, 1000);
    },
    // 获取当前时间
    getCurrentTime() {
      let currentDate = new Date();
      let YYYY = currentDate.getFullYear();
      let MM =
        currentDate.getMonth() + 1 < 10
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1;
      let DD =
        currentDate.getDate() < 10
          ? "0" + currentDate.getDate()
          : currentDate.getDate();
      let hh =
        currentDate.getHours() < 10
          ? "0" + currentDate.getHours()
          : currentDate.getHours();
      let mm =
        currentDate.getMinutes() < 10
          ? "0" + currentDate.getMinutes()
          : currentDate.getMinutes();
      let ss =
        currentDate.getSeconds() < 10
          ? "0" + currentDate.getSeconds()
          : currentDate.getSeconds();
      let ww = currentDate.getDay();
      let weekDay = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ];
      this.currentTime = `${hh}:${mm}:${ss} ${YYYY}/${MM}/${DD} ${weekDay[ww]}`;
      this.currentLunarCalendarDate = getLunarCalendarDate();
    },
    // 园区产业分布滚动条
    portraitEnterprisesItemRingTolling() {
      clearInterval(portraitEnterprisesItemRingTollingTimer);
      let ht = -1;
      let _self = this;
      let hasTime = 0;
      let hasLostTime = 0;
      portraitEnterprisesItemRingTollingTimer = setInterval(function() {
        let portraitEnterprisesItemRing = document.getElementById("portraitEnterprisesItemRing");
        if (portraitEnterprisesItemRing) {
          let height = portraitEnterprisesItemRing.clientHeight;
          if (hasTime === 100) {
            //获取当前滚动条高度
            let current = portraitEnterprisesItemRing.scrollTop;
            if (current === ht) {
              if (hasLostTime === 100) {
                ht = -1;
                portraitEnterprisesItemRing.scrollTop = 0;
                hasTime = 0;
                hasLostTime = 0;
              } else {
                hasLostTime++;
              }
            } else {
              ht = current;
              portraitEnterprisesItemRing.scrollTop = current + 1;
            }
          } else {
            hasTime++;
          }
        }
      }, 100);
    },
    // 园区荣誉滚动条
    parkHonorTolling() {
      clearInterval(parkHonorTollingTimer);
      let ht = -1;
      let _self = this;
      let hasTime = 0;
      let hasLostTime = 0;
      parkHonorTollingTimer = setInterval(function() {
        let parkHonorTimer = document.getElementById("parkHonorTimer");
        if (parkHonorTimer) {
          let height = parkHonorTimer.clientHeight;
          if (hasTime === 100) {
            //获取当前滚动条高度
            let current = parkHonorTimer.scrollTop;
            if (current === ht) {
              if (hasLostTime === 100) {
                ht = -1;
                parkHonorTimer.scrollTop = 0;
                hasTime = 0;
                hasLostTime = 0;
              } else {
                hasLostTime++;
              }
            } else {
              ht = current;
              parkHonorTimer.scrollTop = current + 1;
            }
          } else {
            hasTime++;
          }
        }
      }, 100);
    },
    // 知识产权滚动条
    totalIntellectualPropertyTolling () {
      clearInterval(totalIntellectualPropertyTollingTimer);
      let ht = -1;
      let _self = this;
      let hasTime = 0;
      let hasLostTime = 0;
      totalIntellectualPropertyTollingTimer = setInterval(function() {
        let parkHonorTimer = document.getElementById("totalIntellectualProperty");
        if (parkHonorTimer) {
          let height = parkHonorTimer.clientHeight;
          if (hasTime === 100) {
            //获取当前滚动条高度
            let current = parkHonorTimer.scrollTop;
            if (current === ht) {
              if (hasLostTime === 100) {
                ht = -1;
                parkHonorTimer.scrollTop = 0;
                hasTime = 0;
                hasLostTime = 0;
              } else {
                hasLostTime++;
              }
            } else {
              ht = current;
              parkHonorTimer.scrollTop = current + 1;
            }
          } else {
            hasTime++;
          }
        }
      }, 100);
    },
    // 切换导航
    changeNav(nav) {
      this.currentNav = "";
      if (nav !== "4") {
        this.currentNav2 = "";
      }
      setTimeout(() => {
        this.currentNav = nav;
      }, 600);
    },
    // 子类导航
    changeNav2(nav) {
      this.currentNav2 = "";
      setTimeout(() => {
        this.currentNav2 = nav;
      }, 600);
    },
    // 获取近五年产值和税收
    getOutputValueChartData() {
      this.$axios.get(api.getParkFinance, {})
        .then(res => {
          let data = res.data.data;
          let currentDate = new Date();
          let YYYY = currentDate.getFullYear() - 1;
          let outputValueChartXAxisData = [`${YYYY - 4}`, `${YYYY - 3}`, `${YYYY - 2}`, `${YYYY - 1}`, `${YYYY}`], outputValueChartSeriesOutputValueData = [0, 0, 0, 0, 0], outputValueChartSeriesTaxRevenueData = [0, 0, 0, 0, 0];
          if (data.length > 0) {
            this.page1BottomData = [
              {code: "annualOutput", name: `${data[0].year}年总产值`, icon: "el-icon-damai-shuishou", num: `${data[0].annualOutput}`, unit: "万元"},
              {code: "annualTax", name: `${data[0].year}年总税收`, icon: "el-icon-damai-shuishou", num: `${data[0].annualTax}`, unit: "万元"},
              {code: "perAreaOutput", name: `${data[0].year}年亩均产值`, icon: "el-icon-damai-shuishou", num: `${data[0].perAreaOutput}`, unit: "万元"},
              {code: "perAreaTax", name: `${data[0].year}年亩均税收`, icon: "el-icon-damai-shuishou", num: `${data[0].perAreaTax}`, unit: "万元"}
            ];
          } else {
            this.page1BottomData = [
              {code: "annualOutput", name: `${YYYY}年总产值`, icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
              {code: "annualTax", name: `${YYYY}年总税收`, icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
              {code: "perAreaOutput", name: `${YYYY}年亩均产值`, icon: "el-icon-damai-shuishou", num: "0", unit: "万元"},
              {code: "perAreaTax", name: `${YYYY}年亩均税收`, icon: "el-icon-damai-shuishou", num: "0", unit: "万元"}
            ];
          }
          data.map(v => {
            outputValueChartXAxisData.map((year, yearIndex) => {
              if (v.year === year) {
                outputValueChartSeriesOutputValueData[yearIndex] =
                  v.annualOutput;
                outputValueChartSeriesTaxRevenueData[yearIndex] = v.annualTax;
              }
            });
          });
          this.outputValueChartXAxis = {
            type: "category",
            name: "年份",
            nameTextStyle: {color: "#ffffff"},
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: outputValueChartXAxisData
          };
          this.outputValueChartSeries = [
            {
              name: "产值",
              type: "line",
              stack: "产值",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#0DFDF266"},
                  {offset: 1, color: "#0DFDF200"}
                ])
              },
              data: outputValueChartSeriesOutputValueData
            },
            {
              name: "税收",
              type: "line",
              stack: "税收",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#F47153"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#F4715366"},
                  {offset: 1, color: "#F4715300"}
                ])
              },
              data: outputValueChartSeriesTaxRevenueData
            }
          ];
        })
        .catch(errorHandler("获取园区荣誉失败"));
    },
    // 获取近五年入驻企业数
    getFiveYearsEnterprisesCharData() {
      this.$axios.get(api.getEnterpriseEnterData, {})
        .then(res => {
          let data = res.data.data;
          let enterEnterpriseCount = data.enterEnterpriseCount
          if (this.yqCode === 'gjzz') {
            if (!enterEnterpriseCount) {
              this.enterpriseCultivationData[0].num = 41;
              this.pageTopData[3].num = 41
            } else {
              this.enterpriseCultivationData[0].num = enterEnterpriseCount;
              this.pageTopData[3].num = enterEnterpriseCount
            }
            let enterEnterpriseData = [
              {year: '2017', num: 38},
              {year: '2018', num: 43},
              {year: '2019', num: 40},
              {year: '2020', num: 39},
              {year: '2021', num: 41}
            ], fiveYearsEnterprisesChartXAxisData = [], fiveYearsEnterprisesChartSeriesData = [];
            enterEnterpriseData.map(v => {
              fiveYearsEnterprisesChartXAxisData.push(v.year);
              fiveYearsEnterprisesChartSeriesData.push(v.num);
            })
            this.fiveYearsEnterprisesChartXAxis = {
              type: "category",
              name: "日期",
              // boundaryGap: false,
              nameTextStyle: {
                color: "#ffffff"
              },
              axisLine: {
                lineStyle: {
                  color: "#ffffff"
                }
              },
              data: fiveYearsEnterprisesChartXAxisData
            };
            this.fiveYearsEnterprisesChartSeries = [
              {
                name: "入驻企业数",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                barWidth: "40%",
                itemStyle: {
                  color: '#0DFDF2'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#0DFDF266"},
                    {offset: 1, color: "#0DFDF200"}
                  ])
                },
                data: fiveYearsEnterprisesChartSeriesData
              }
            ];
          } else {
            this.enterpriseCultivationData[0].num = enterEnterpriseCount || 0;
            this.pageTopData[3].num = enterEnterpriseCount
            let enterEnterpriseData = data.enterEnterpriseData, fiveYearsEnterprisesChartXAxisData = [], fiveYearsEnterprisesChartSeriesData = [];
            for (let i in enterEnterpriseData) {
              fiveYearsEnterprisesChartXAxisData.push(i);
              fiveYearsEnterprisesChartSeriesData.push(enterEnterpriseData[i]);
            }
            this.fiveYearsEnterprisesChartXAxis = {
              type: "category",
              name: "日期",
              // boundaryGap: false,
              nameTextStyle: {
                color: "#ffffff"
              },
              axisLine: {
                lineStyle: {
                  color: "#ffffff"
                }
              },
              data: fiveYearsEnterprisesChartXAxisData
            };
            this.fiveYearsEnterprisesChartSeries = [
              {
                name: "入驻企业数",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                barWidth: "40%",
                itemStyle: {
                  color: '#0DFDF2'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#0DFDF266"},
                    {offset: 1, color: "#0DFDF200"}
                  ])
                },
                data: fiveYearsEnterprisesChartSeriesData
              }
            ];
          }
        })
        .catch(errorHandler("获取近五年入驻企业数失败"));
    },
    // 获取企业类别统计
    getEnterpriseCategoryChartData() {
      this.$axios.get(api.getEnterprisePatentData, {})
        .then(res => {
          let data = res.data.data;

            let businessRevenueConfigData = [], parkPatentEnterpriseData = data.parkPatentEnterpriseData || {}
            for (let k in parkPatentEnterpriseData) {
              let arr = [`<i style='color:#08C8B7' class='el-icon-damai-qiye11'></i>${k}`, parkPatentEnterpriseData[k]];
              businessRevenueConfigData.push(arr);
            }
            this.businessRevenueConfig = {
              header: ["企业名称", "知识产权数"],
              columnWidth: [200, 100],
              align: ['left', 'center'],
              waitTime: 5000,
              headerHeight: 24,
              headerBGC: "#ffffff00",
              oddRowBGC: "#ffffff00",
              evenRowBGC: "#122C4799",
              data: businessRevenueConfigData
            }
            this.enterpriseCultivationData[4].num = data.parkTotalPatentCount || 0;
            let parkPatentIndustryData = data.patentCategoryData || {},
              enterpriseCategoryData = data.enterpriseCategoryData,
              enterpriseCategoryChartXAxisData = [],
              enterpriseCategoryChartSeriesData = [],
              totalIntellectualPropertyConfig = [],
              totalIntellectualPropertyConfigMaxValue = 0,
              totalEnterpriseCategoryDataMaxValue = 10,
              totalIntellectualPropertyConfigMaxValueArr = []
            for (let category in enterpriseCategoryData) {
              if (totalEnterpriseCategoryDataMaxValue < enterpriseCategoryData[category]) {
                totalEnterpriseCategoryDataMaxValue = enterpriseCategoryData[category]
              }
              enterpriseCategoryChartXAxisData.push(category);
              enterpriseCategoryChartSeriesData.push(
                enterpriseCategoryData[category]
              );
            }
            let totalEnterpriseCategoryDataMaxValueRounding = ''
            let len = totalEnterpriseCategoryDataMaxValue.toString().length;
            if (len <= 1) {
              totalEnterpriseCategoryDataMaxValueRounding = 10
            } else {
              let mult = Math.pow(10, 1);
              totalEnterpriseCategoryDataMaxValueRounding = Math.ceil(totalEnterpriseCategoryDataMaxValue / mult) * mult
            }
            enterpriseCategoryChartSeriesData.map(v => {
              totalIntellectualPropertyConfigMaxValueArr.push(totalEnterpriseCategoryDataMaxValueRounding)
            })
            for (let i in parkPatentIndustryData) {
              if (totalIntellectualPropertyConfigMaxValue < parkPatentIndustryData[i]) {
                totalIntellectualPropertyConfigMaxValue = parkPatentIndustryData[i]
              }
              let obj = {
                name: i,
                num: parkPatentIndustryData[i]
              };
              totalIntellectualPropertyConfig.push(obj);
            }

            totalIntellectualPropertyConfig.map(v => {
              v.width = `${(v.num / totalIntellectualPropertyConfigMaxValue * 100).toFixed(2)}%`
            })
            this.totalIntellectualPropertyConfig = totalIntellectualPropertyConfig
            this.enterpriseCategoryChartXAxis = {
              type: "category",
              name: "日期",
              nameTextStyle: {
                color: "#ffffff"
              },
              axisLine: {
                lineStyle: {
                  color: "#ffffff"
                }
              },
              data: enterpriseCategoryChartXAxisData
            };
            this.enterpriseCategoryChartSeries = [
              {
                name: "企业类别统计",
                type: "bar",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                barWidth : 20,
                // showBackground: true,
                // backgroundStyle: {
                //   borderRadius: [10, 10, 10, 10],
                //   color: '#909090'
                // },
                itemStyle: {
                  // barBorderRadius: [10, 10, 10, 10],
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#08E8A4"},
                    {offset: 1, color: "#02B1FF"}
                  ])
                },
                z: 1,
                data: enterpriseCategoryChartSeriesData
              },
              {
                // 分隔
                type: "pictorialBar",
                itemStyle: {
                  normal:{
                    color:"#061348"
                  }
                },
                symbolRepeat: "fixed",
                symbolMargin: 5,
                symbol: "rect",
                symbolClip: true,
                symbolSize: [18, 1],
                symbolPosition: "center",
                symbolOffset: [-2, 0],
                symbolBoundingData: totalEnterpriseCategoryDataMaxValue,
                data: enterpriseCategoryChartSeriesData,
                z: 2,
              },
              {
                name: "外框",
                type: "bar",
                barGap: "-120%", // 设置外框位置
                data: totalIntellectualPropertyConfigMaxValueArr,
                barWidth: 28,
                itemStyle: {
                  normal: {
                    color: "transparent", // 填充色
                    barBorderColor: "#1C4B8E", // 边框色
                    barBorderWidth: 1, // 边框宽度
                    // barBorderRadius: 0, //圆角半径
                    label: {
                      // 标签显示位置
                      show: false,
                      position: "top" // insideTop 或者横向的 insideLeft
                    }
                  }
                },
                z: 0
              }
            ];

        })
        .catch(errorHandler("获取企业类别统计失败"));
    },
    // 获取孵化信息
    getEnterpriseHatchData() {
      this.$axios.get(api.getEnterpriseHatchData, {})
        .then(res => {
          let data = res.data.data;
          this.enterpriseCultivationData[1].num = data.enterpriseTotalIncome || 0;
          this.enterpriseCultivationData[2].num = data.financingMoneyCount || 0;
          this.enterpriseCultivationData[3].num = data.financingMoney || 0;
          this.page2BottomData.map(v => {
            v.num = data[v.code] || 0;
          });
          // if (this.yqCode === 'gjzz') {
          //   this.enterpriseCultivationData[1].num = data.enterpriseTotalIncome || 0;
          //   this.enterpriseCultivationData[2].num = data.financingMoneyCount || 0;
          //   this.enterpriseCultivationData[3].num = data.financingMoney || 0;
          //   this.page2BottomData.map(v => {
          //     v.num = data[v.code] || 0;
          //   });
          // } else {
          //   this.enterpriseCultivationData[1].num = data.enterpriseTotalIncome || 0;
          //   this.enterpriseCultivationData[2].num = data.financingMoneyCount || 0;
          //   this.enterpriseCultivationData[3].num = data.financingMoney || 0;
          //   this.page2BottomData.map(v => {
          //     v.num = data[v.code] || 0;
          //   });
          // }

          // let hatchProperty = data.hatchProperty, totalIntellectualPropertyConfig = [
          //     {name: '发明专利', code: 'activePatent', num: 0},
          //     {name: '软件著作权', code: 'softwareWorks', num: 0},
          //     {name: '植物新物种', code: 'plant', num: 0},
          //     {name: '集成电路布图', code: 'ic', num: 0},
          //   ], totalIntellectualPropertyConfigMaxValue = 0, totalIntellectualPropertyConfigMaxValueArr = []
          // totalIntellectualPropertyConfig.map(v => {
          //   if (totalIntellectualPropertyConfigMaxValue < hatchProperty[v.code]) {
          //     totalIntellectualPropertyConfigMaxValue = hatchProperty[v.code]
          //   }
          //   v.num = hatchProperty[v.code]
          // })
          // totalIntellectualPropertyConfig.map(v => {
          //   v.width = `${(v.num / totalIntellectualPropertyConfigMaxValue * 100).toFixed(2)}%`
          // })
          // this.totalIntellectualPropertyConfig = totalIntellectualPropertyConfig
        })
        .catch(errorHandler("获取孵化信息失败"));
    },

    // 获取园区物业工单统计
    getPropertyWorkOrderChartData() {
      this.$axios.get(api.getInteractionData, {})
        .then(res => {
          let data = res.data.data;
          let totalPropertyWorkOrderTopDataMaxValue = 0,
            totalPropertyWorkOrderTopDataMaxValueArr = [],
            totalPropertyWorkOrderTopDataMaxValueRounding = ''
          this.propertyWorkOrderTopData.map(v => {
            v.num = data[v.code]
          })
          this.parkServicesData[0].num = data.repairRecordCount;
          let repairStatistic = data.repairStatistic || [];
          let xData = [];
          let series = [];
          repairStatistic.map(v => {
            if (totalPropertyWorkOrderTopDataMaxValue < v.workOrderAmount) {
              totalPropertyWorkOrderTopDataMaxValue = v.workOrderAmount
            }
            xData.push(v.time);
            series.push(v.workOrderAmount);
          });
          let len = totalPropertyWorkOrderTopDataMaxValue.toString().length;
          if (len <= 1) {
            totalPropertyWorkOrderTopDataMaxValueRounding = 10
          } else {
            let mult = Math.pow(10, 1);
            totalPropertyWorkOrderTopDataMaxValueRounding = Math.ceil(totalPropertyWorkOrderTopDataMaxValue / mult) * mult
          }
          series.map(v => {
            totalPropertyWorkOrderTopDataMaxValueArr.push(totalPropertyWorkOrderTopDataMaxValueRounding)
          })
          this.propertyWorkOrderChartXAxis = {
            type: "category",
            name: "日期",
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: xData
          };
          this.propertyWorkOrderChartSeries = [
            {
              name: "物业工单统计",
              type: "bar",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: 18,
              // showBackground: true,
              // backgroundStyle: {
              //   borderRadius: [10, 10, 10, 10],
              //   color: '#909090'
              // },
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#08E8A4"},
                  {offset: 1, color: "#02B1FF"}
                ])
              },
              z: 1,
              data: series
            }, {
              // 分隔
              type: "pictorialBar",
              itemStyle: {
                normal:{
                  color:"#061348"
                }
              },
              symbolRepeat: "fixed",
              symbolMargin: 4,
              symbol: "rect",
              symbolClip: true,
              symbolSize: [16, 1],
              symbolPosition: "center",
              symbolOffset: [-2, 0],
              symbolBoundingData: totalPropertyWorkOrderTopDataMaxValue,
              data: series,
              z: 2,
            }, {
              name: "外框",
              type: "bar",
              barGap: "-120%", // 设置外框位置
              data: totalPropertyWorkOrderTopDataMaxValueArr,
              barWidth: 26,
              itemStyle: {
                normal: {
                  color: "transparent", // 填充色
                  barBorderColor: "#1C4B8E", // 边框色
                  barBorderWidth: 1, // 边框宽度
                  // barBorderRadius: 0, //圆角半径
                  label: {
                    // 标签显示位置
                    show: false,
                    position: "top" // insideTop 或者横向的 insideLeft
                  }
                }
              },
              z: 0
            }
          ];
        })
        .catch(errorHandler("获取报修数据失败"));
    },
    // 获取巡检数据
    getInspectionChartData() {
      this.$axios.get(api.getInspectData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[1].num = data.inspectCompleteTaskCount;
          this.inspectionTopData = [
            { name: "巡检点数量", value: data.inspectPointCount || 0 },
            { name: "巡检任务", value: data.inspectTaskCount || 0 },
            { name: "巡检班组", value: data.inspectTeamCount || 0 },
            { name: "巡检人员", value: data.inspectPersonCount || 0 }
          ];
          this.finishOnTimeSeries = [
            {
              name: "按时完成率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskCompleteRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#1CCFD1",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#1CCFD1"] // 100% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#1CCFD199"] // 0% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.kuangXunSeries = [
            {
              name: "旷巡率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskWasteRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#56AEF1",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#56AEF1"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#56AEF199"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.missedInspectionSeries = [
            {
              name: "漏巡率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskOmitRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#D4AF1D",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#D4AF1D"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#D4AF1D99"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.breakdownSeries = [
            {
              name: "故障率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectBadStatusRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#945FF8",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#945FF8"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#945FF899"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
        })
        .catch(errorHandler("获取巡检数据失败"));
    },
    // 获取开票数据
    getInvoiceChartData() {
      this.$axios.get(api.getInvoiceData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[2].num = data.totalInvoiceCount;
          let invoiceStatistic = data.invoiceStatistic || [];
          let xData = [],
            series = [];
          invoiceStatistic.map(v => {
            xData.push(v.time);
            series.push(v.invoiceNumber)
            // series.push((v.totalInvoicingMoney / 10000).toFixed(2));
          });
          this.invoiceChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: xData
          };
          this.invoiceChartSeries = [
            {
              name: "开票次数",
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0DFDF266"
                  },
                  {
                    offset: 1,
                    color: "#32C5E900"
                  }
                ])
              },
              data: series
            }
          ];
        })
        .catch(errorHandler("获取开票数据失败"));
    },
    // 获取严选服务数据
    getValueAddedChartData() {
      this.$axios.get(api.getValueAddedData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[4].num = data.valueaddItemCount;
          let valueaddStatistic = data.valueaddStatistic || [];
          let valueaddMaxValue = 0;
          let valueAddedDataConfigData = [];
          for (let i in valueaddStatistic) {
            if (valueaddMaxValue < parseInt(valueaddStatistic[i])) {
              valueaddMaxValue = parseInt(valueaddStatistic[i])
            }
            let obj = {
              name: i,
              value: parseInt(valueaddStatistic[i])
            };
            valueAddedDataConfigData.push(obj);
          }
          valueAddedDataConfigData.map(v => {
            v.width = `${(v.value / valueaddMaxValue * 100).toFixed(2)}%`
          })
          this.valueAddedDataConfig = {
            data: valueAddedDataConfigData,
            // colors: ['#fb1313', '#FB4E13', '#FB7F13', '#FBA813', '#FBD013'],
            showValue: true
          };
        })
        .catch(errorHandler("获取严选服务数据失败"));
    },
    // 消息
    getMessageData() {
      this.$axios.get(api.getMessageData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[3].num = data.hqptPolicyViews;
          this.page3BottomData.map(v => {
            v.num = data[v.code];
          });
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取设备运行状况
    getEquipmentOperationStatusChartData() {
      this.$axios.get(api.getDeviceData, {})
        .then(res => {
          let data = res.data.data;
          let onlineDeviceCount = +data.onlineDeviceCount;
          let offlineDeviceCount = +data.offlineDeviceCount;
          let deviceStatisticsList = data.devicesStatus || [];
          deviceStatisticsList.map(v => {
            let allNum = v.online + v.offline;
            if (allNum === 0) {
              v.onlineWidth = "100%";
            } else {
              v.onlineWidth = `${((parseInt(v.online) / allNum) * 100).toFixed(2)}%`;
            }
          });
          this.equipmentOperationStatusConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              center: ["50%", "50%"],
              data: [
                { name: "在线", value: onlineDeviceCount },
                { name: "离线", value: offlineDeviceCount }
              ],
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ];
          this.deviceStatisticsList = deviceStatisticsList;
          this.deviceNumData = [
            { name: "设备总数", num: data.totalDeviceCount },
            { name: "正常在线", num: data.onlineDeviceCount }
          ];
          this.page4BottomData_1.map(v => {
            v.num = data[v.code];
          });
        })
        .catch(errorHandler("获取设备信息失败"));
    },

    // 获取门禁出入流量
    getAccessControlChartData() {
      this.$axios.get(api.getPersonTrafficData, {})
        .then(res => {
          let data = res.data.data;
          this.page4BottomData_2.map(v => {
            v.num = data[v.code];
          });
          let accessControlChartXAxisData = [],
            accessControlChartSeriesInData = [],
            accessControlChartSeriesOutData = [],
            ladderControlChartXAxisData = [],
            ladderControlChartSeriesData = [],
            visitorChartXAxisData = [],
            visitorChartSeriesData = [];
          data.guardWeeklyTraffic.map(v => {
            if (v.time) {
              v.time = v.time.slice(5, 19)
            }
            accessControlChartXAxisData.push(v.time);
            accessControlChartSeriesInData.push(v.passInNumber || v.swingCardNumber);
            accessControlChartSeriesOutData.push(v.passOutNumber);
          });
          this.accessControlChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: accessControlChartXAxisData
          };
          this.accessControlChartSeries = [
            {
              name: "进流量",
              type: "line",
              stack: "进流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#0DFDF266"},
                  {offset: 1, color: "#0DFDF200"}
                ])
              },
              data: accessControlChartSeriesInData
            },
            {
              name: "出流量",
              type: "line",
              stack: "出流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#40E971"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#40E97166"},
                  {offset: 1, color: "#40E97100"}
                ])
              },
              data: accessControlChartSeriesOutData
            }
          ];

          data.liftWeeklyTraffic.map(v => {
            if (v.date) {
              v.date = v.date.slice(5, 19)
            }
            ladderControlChartXAxisData.push(v.date);
            ladderControlChartSeriesData.push(v.count);
          });
          this.ladderControlChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: ladderControlChartXAxisData
          };
          this.ladderControlChartSeries = [
            {
              name: "出入流量",
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0DFDF2"
                  },
                  {
                    offset: 1,
                    color: "#0DFDF200"
                  }
                ])
              },
              data: ladderControlChartSeriesData
            }
          ];

          let totalVisitorChartSeriesMaxValue = 0, totalVisitorChartSeriesMaxValueRounding = '', totalVisitorChartSeriesMaxValueArr = []
          data.visitorWeeklyTraffic.map(v => {
            if (totalVisitorChartSeriesMaxValue < v.count) {
              totalVisitorChartSeriesMaxValue = v.count
            }
            if (v.date) {
              v.date = v.date.slice(5, 19)
            }
            visitorChartXAxisData.push(v.date);
            visitorChartSeriesData.push(v.count);
          });
          let len = totalVisitorChartSeriesMaxValue.toString().length;
          if (len <= 1) {
            totalVisitorChartSeriesMaxValueRounding = 10
          } else {
            let mult = Math.pow(10, 1);
            totalVisitorChartSeriesMaxValueRounding = Math.ceil(totalVisitorChartSeriesMaxValue / mult) * mult
          }
          visitorChartSeriesData.map(v => {
            totalVisitorChartSeriesMaxValueArr.push(totalVisitorChartSeriesMaxValueRounding)
          })
          this.visitorChartXAxis = {
            type: "category",
            name: "日期",
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: visitorChartXAxisData
          };
          this.visitorChartSeries = [
            {
              name: "访客人数",
              type: "bar",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: 18,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#08E8A4"},
                  {offset: 1, color: "#02B1FF"}
                ])
              },
              z: 1,
              data: visitorChartSeriesData
            }, {
              // 分隔
              type: "pictorialBar",
              itemStyle: {
                normal:{
                  color:"#061348"
                }
              },
              symbolRepeat: "fixed",
              symbolMargin: 4,
              symbol: "rect",
              symbolClip: true,
              symbolSize: [16, 1],
              symbolPosition: "center",
              symbolOffset: [-2, 0],
              symbolBoundingData: totalVisitorChartSeriesMaxValue,
              data: visitorChartSeriesData,
              z: 2,
            }, {
              name: "外框",
              type: "bar",
              barGap: "-120%", // 设置外框位置
              data: totalVisitorChartSeriesMaxValueArr,
              barWidth: 26,
              itemStyle: {
                normal: {
                  color: "transparent", // 填充色
                  barBorderColor: "#1C4B8E", // 边框色
                  barBorderWidth: 1, // 边框宽度
                  // barBorderRadius: 0, //圆角半径
                  label: {
                    // 标签显示位置
                    show: false,
                    position: "top" // insideTop 或者横向的 insideLeft
                  }
                }
              },
              z: 0
            }
          ];
        })
        .catch(errorHandler("获取设备信息失败"));
    },

    // 获取近七天车流量统计
    getTrafficVolumeChartData() {
      this.$axios.get(api.getCarTrafficData, {})
        .then(res => {
          let data = res.data.data;
          this.todayParkingTopData.map(v => {
            v.num = data[v.code];
          })
          this.page4BottomData_3.map(v => {
            v.num = data[v.code];
          });
          let trafficVolumeChartXAxisData = [],
            trafficVolumeChartSeriesInData = [],
            trafficVolumeChartSeriesOutData = [],
            parkingChargeChartTemporarySeries = [],
            parkingChargeChartMonthlySeries = [];
          data.carWeeklyTraffic.map(v => {
            if (v.time) {
              v.time = v.time.slice(5, 19)
            }
            trafficVolumeChartXAxisData.push(v.time);
            trafficVolumeChartSeriesInData.push(v.carInNumber);
            trafficVolumeChartSeriesOutData.push(v.carOutNumber);
            parkingChargeChartTemporarySeries.push(v.temporaryStopMoney);
            parkingChargeChartMonthlySeries.push(v.monthlyStopMoney);
          });
          this.trafficVolumeChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: trafficVolumeChartXAxisData
          };
          this.trafficVolumeChartSeries = [
            {
              name: "进场",
              type: "line",
              stack: "进场",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#32C5E9"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#32C5E966"},
                  {offset: 1, color: "#32C5E911"}
                ])
              },
              data: trafficVolumeChartSeriesInData
            },
            {
              name: "出场",
              type: "line",
              stack: "出场",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#29E065"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#29E06566"},
                  {offset: 1, color: "#29E06511"}
                ])
              },
              data: trafficVolumeChartSeriesOutData
            }
          ];
          this.parkingChargeChartXAxis = {
            type: "category",
            name: "日期",
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: trafficVolumeChartXAxisData
          };
          this.parkingChargeChartSeries = [
            {
              name: "临停收费",
              type: "bar",
              stack: "临停收费",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#32C5E966"},
                  {offset: 1, color: "#32C5E911"}
                ])
              },
              data: parkingChargeChartTemporarySeries
            },
            {
              name: "包月收费",
              type: "bar",
              stack: "包月收费",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#29E06566"
                  },
                  {offset: 1, color: "#29E06511"}
                ])
              },
              data: parkingChargeChartMonthlySeries
            }
          ];
        })
        .catch(errorHandler("获取流量信息失败"));
    },

    // 能耗数据
    getEngeryConsumptionData() {
      this.$axios.get(api.getEngeryConsumptionData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[3].num = data.hqptPolicyViews;
          this.page4BottomData_4.map(v => {
            if (this.yqCode === 'gjzz' && v.code === 'monthlyEletricCost') {
              v.num = (parseFloat(this.page4BottomData_4[0].num) * 0.98).toFixed(2).toString()
            } else {
              v.num = data[v.code];
            }
          });
          let monthlyElectricStatistic = data.monthlyElectricStatistic || [], electricityMonthConfigData = [], monthlyWaterStatistic = data.halfYearWaterData[0].details || [
            {waterSceneName: "公共用水", waterSceneData: 0, waterSceneMoney: 0},
            {waterSceneName: "租户用水", waterSceneData: 0, waterSceneMoney: 0}
          ], waterMonthConfigData = [];
          monthlyElectricStatistic.map(v => {
            let obj = {
              name: v.electricSceneName,
              value: (parseFloat(v.electricSceneData) / 10000).toFixed(2)
            };
            electricityMonthConfigData.push(obj);
          });
          monthlyWaterStatistic.map(v => {
            let obj = {
              name: v.waterSceneName,
              value: (parseFloat(v.waterSceneData) / 10000).toFixed(2)
            };
            waterMonthConfigData.push(obj);
          });

          // 获取当月用电情况
          this.electricityMonthConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              data: electricityMonthConfigData,
              tooltip: {
                formatter: '{b}<br/>{c}万度 ({d}%)'
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "14"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ];
          // 获取当月用水情况
          this.waterMonthConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              data: waterMonthConfigData,
              tooltip: {
                formatter: '{b}<br/>{c}万度 ({d}%)'
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "14"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ];

          let halfYearElectricData = data.halfYearElectricData || [], electricSceneNameArr = [], halfYearElectricityChartXAxisData = [], halfYearElectricityChartSeriesData = [], halfYearTariffChartSeriesData = [];
          halfYearElectricData.map((v, i) => {
            halfYearElectricityChartXAxisData.push(v.billTime);
            let details = v.details || [];
            details.map((detailsItem, detailsIndex) => {
              if (electricSceneNameArr.indexOf(detailsItem.electricSceneName) === -1) {
                electricSceneNameArr.push(detailsItem.electricSceneName);
                halfYearElectricityChartSeriesData[detailsIndex] = [];
                halfYearElectricityChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.electricSceneData) / 10000).toFixed(2);
                halfYearTariffChartSeriesData[detailsIndex] = [];
                halfYearTariffChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.electricSceneMoney) / 10000).toFixed(2);
              } else {
                halfYearElectricityChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.electricSceneData) / 10000).toFixed(2);
                halfYearTariffChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.electricSceneMoney) / 10000).toFixed(2);
              }
            });
          });
          let colorList = ['#12FDF0', '#E2F58B', '#F47153', "#32C5E9", "#29E065", "#ed7d31", "#FFC000", "#A5A5A5", "#C2A753", "#4BB66E", "#FFA336", "#53A5BC"];
          // 近半年用电量统计
          let halfYearElectricityChartSeries = [], halfYearTariffChartSeries = [];
          halfYearElectricityChartSeriesData.map((v, i) => {
            halfYearElectricityChartSeries[i] = {
              name: electricSceneNameArr[i],
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: colorList[i]
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: `${colorList[i]}66`},
                  {offset: 1, color: `${colorList[i]}00`}
                ])
              },
              data: v
            };
          });
          halfYearTariffChartSeriesData.map((v, i) => {
            halfYearTariffChartSeries[i] = {
              name: electricSceneNameArr[i],
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: colorList[i]
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: `${colorList[i]}66`},
                  {offset: 1, color: `${colorList[i]}00`}
                ])
              },
              data: v
            };
          });

          this.halfYearElectricityChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: halfYearElectricityChartXAxisData
          };
          this.halfYearElectricityChartSeries = halfYearElectricityChartSeries;

          // 近半年电费情况
          this.halfYearTariffChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: halfYearElectricityChartXAxisData
          };
          this.halfYearTariffChartSeries = halfYearTariffChartSeries;

          // 近半年用水量统计
          let halfYearWaterData = data.halfYearWaterData || [], waterSceneNameArr = [], halfYearWaterChartXAxisData = [], halfYearWaterChartSeriesData = [];
          halfYearWaterData.map((v, i) => {
            halfYearWaterChartXAxisData.push(v.billTime);
            let details = v.details || [];
            details.map((detailsItem, detailsIndex) => {
              if (waterSceneNameArr.indexOf(detailsItem.waterSceneName) === -1) {
                waterSceneNameArr.push(detailsItem.waterSceneName);
                halfYearWaterChartSeriesData[detailsIndex] = [];
                halfYearWaterChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.waterSceneData) / 10000).toFixed(2);
              } else {
                halfYearWaterChartSeriesData[detailsIndex][i] = (parseFloat(detailsItem.waterSceneData) / 10000).toFixed(2);
              }
            });
          });
          let halfYearWaterChartSeries = [];
          halfYearWaterChartSeriesData.map((v, i) => {
            halfYearWaterChartSeries[i] = {
              name: waterSceneNameArr[i],
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: colorList[i]
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: `${colorList[i]}66`},
                  {offset: 1, color: `${colorList[i]}00`}
                ])
              },
              data: v
            };
          });

          this.halfYearWaterChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: halfYearWaterChartXAxisData
          };
          this.halfYearWaterChartSeries = halfYearWaterChartSeries;

          // 企业能耗排行
          let enterpriseElectricRank = data.enterpriseElectricRank, enterpriseEnergyConsumptionConfigData = [], electricValueMax = '', waterValueMax = '';
          if (enterpriseElectricRank.length > 3) {
            enterpriseElectricRank.length = 3
          }
          enterpriseElectricRank.map(v => {
            if (electricValueMax < (v.common + v.publicElectricity)) {
              electricValueMax = v.common + v.publicElectricity
            }
            let obj = {
              name: v.relateEnterpriseName,
              electricValue: v.common + v.publicElectricity,
              electricWidth: '',
              waterValue: 0,
              waterWidth: '0%',
            }
            enterpriseEnergyConsumptionConfigData.push(obj);
          });
          enterpriseEnergyConsumptionConfigData.map(v => {
            v.electricWidth = `${(v.electricValue / electricValueMax * 100).toFixed(2)}%`
          })
          this.enterpriseEnergyConsumptionConfigData = enterpriseEnergyConsumptionConfigData
        })
        .catch(errorHandler("获取能耗数据失败"));
    },

    // 消防数据
    getFscAlarmOverviewData() {
      this.$axios.post(api.fscAlarmOverview, {})
        .then(res => {
          let data = res.data.data;
          this.page4BottomData_5.map(v => {
            v.num = data[v.code]
          })
          let totalCount = data.totalCount
          let onlineCount = data.onlineCount
          this.fireControlDeviceNumData = [
            { name: "设备总数", num: totalCount },
            { name: "正常在线", num: onlineCount }
          ]
          this.fireControlEquipmentOperationStatusConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              center: ["50%", "50%"],
              data: [
                { name: "在线", value: onlineCount },
                { name: "离线", value: (parseInt(totalCount) - parseInt(onlineCount)).toFixed(0) }
              ],
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
          let todayAlarmRecord = data.todayAlarmRecord || [], callThePoliceTodayRecordConfigData = []
          todayAlarmRecord.map(v => {
            if (v.uploadTime) {
              v.uploadTime = v.uploadTime.slice(11, 19)
            }
            let arr = [v.deviceName, v.uploadTime, v.alarmStatus];
            callThePoliceTodayRecordConfigData.push(arr)
            if (callThePoliceTodayRecordConfigData.length > 5) {
              callThePoliceTodayRecordConfigData.length = 5
            }
          })
          let callThePoliceTodayRecordConfig = {
            header: ["报警设备", "报警时间", "状态"],
            columnWidth: [120, 150, 120],
            align: ['left', 'left', 'left'],
            waitTime: 5000,
            headerHeight: 24,
            headerBGC: "#ffffff00",
            oddRowBGC: "#ffffff00",
            evenRowBGC: "#122C4799",
            data: callThePoliceTodayRecordConfigData
          }
          this.callThePoliceTodayRecordConfig = callThePoliceTodayRecordConfig

          // 企业能耗排行
          let alarmMonthRankList = data.alarmMonthRankList || [], fireControlConsumptionConfigData = [], alarmCountMax = '', waterValueMax = '';
          if (alarmMonthRankList.length > 3) {
            alarmMonthRankList.length = 3
          }
          alarmMonthRankList.map(v => {
            if (alarmCountMax < v.alarmCount) {
              alarmCountMax = v.alarmCount
            }
            let obj = {
              deviceName: v.deviceName,
              alarmType: v.alarmType,
              alarmWidth: '',
              alarmCount: v.alarmCount
            }
            fireControlConsumptionConfigData.push(obj);
          });
          fireControlConsumptionConfigData.map(v => {
            v.alarmWidth = `${(v.alarmCount / alarmCountMax * 100).toFixed(2)}%`
          })
          this.fireControlConsumptionConfigData = fireControlConsumptionConfigData

        })
        .catch(errorHandler("获取消防数据失败"));
    },

    // 建立长连接
    connection() {
      // 建立连接对象
      this.socket = new SockJS("https://yq.damaiiot.com/stomp"); //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
      // 获取STOMP子协议的客户端对象
      // this.stompClient = Stomp.client('http://118.178.227.11:15674/ws');
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.heartbeat.outgoing = 10000;
      this.stompClient.heartbeat.incoming = 10000;
      // 定义客户端的认证信息,按需求配置
      let headers = {
        login: "admin",
        passcode: "damai0919damaiiot***",
        // additional header
        "client-id": "my-client-id"
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(
        headers,
        frame => {
          // 入场监听队列
          let personRecordExchangeTopic = `/exchange/person_record_exchange_topic/${bus.global.yqCode}`;
          let carInExchange = `/exchange/carInExchange/${bus.global.yqCode}`;
          let carOutExchange = `/exchange/carOutExchange/${bus.global.yqCode}`;

          this.stompClient.subscribe(personRecordExchangeTopic, msg => {
            let data = JSON.parse(msg.body);
            console.log(data)
            let personnelAccessRecordConfigData = this.personnelAccessRecordConfig.data
            if (data.openTime) {
              data.openTime = data.openTime.slice(11, 19)
            }
            let arr = [`<i style='color:#08C8B7' class='el-icon-damai-chengshijinglixianxing'></i>${data.personName}`, data.deviceName, data.openTime];
            personnelAccessRecordConfigData.unshift(arr)
            if (personnelAccessRecordConfigData.length > 5) {
              personnelAccessRecordConfigData.length = 5
            }
            let personnelAccessRecordConfig = {
              header: ["姓名", "进出位置", "进出时间"],
              columnWidth: [120, 150, 120],
              align: ['left', 'left', 'left'],
              waitTime: 5000,
              headerHeight: 24,
              headerBGC: "#ffffff00",
              oddRowBGC: "#ffffff00",
              evenRowBGC: "#122C4799",
              data: personnelAccessRecordConfigData
            }
            this.personnelAccessRecordConfig = personnelAccessRecordConfig
            this.pageTopData[0].num += 1
          });
          this.stompClient.subscribe(carInExchange, msg => {
            let data = JSON.parse(msg.body);
            if (data.parkingType === '1') {
              data.parkingTypeText = '包月车'
            } else if (data.parkingType === '2') {
              data.parkingTypeText = '临停车'
            } else if (data.parkingType === '3') {
              data.parkingTypeText = '白名单'
            } else if (data.parkingType === '4') {
              data.parkingTypeText = '白名单车'
            } else if (data.parkingType === '5') {
              data.parkingTypeText = '黑名单车'
            }
            console.log(data);
            this.pageTopData[1].num += 1
            this.carInData = data
          });
          this.stompClient.subscribe(carOutExchange, msg => {
            let data = JSON.parse(msg.body);
            if (data.parkingType === '1') {
              data.parkingTypeText = '包月车'
            } else if (data.parkingType === '2') {
              data.parkingTypeText = '临停车'
            } else if (data.parkingType === '3') {
              data.parkingTypeText = '白名单'
            } else if (data.parkingType === '4') {
              data.parkingTypeText = '白名单车'
            } else if (data.parkingType === '5') {
              data.parkingTypeText = '黑名单车'
            }
            console.log(data);
            this.pageTopData[1].num += 1
            this.carOutData = data
          });

          let deviceStatusQueue = `/exchange/alarm_device_status_exchange/${bus.global.yqCode}`;
          let alarmOpenRecordQueue = `/exchange/alarm_open_record_exchange/${bus.global.yqCode}`;
          let alarmCloseRecordQueue = `/exchange/alarm_close_record_exchange/${bus.global.yqCode}`;

          this.stompClient.subscribe(deviceStatusQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
          });
          this.stompClient.subscribe(alarmOpenRecordQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
            this.getAlarmStatistics();
            this.getMonthAlarmRankList();
          });
          this.stompClient.subscribe(alarmCloseRecordQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
            this.getAlarmStatistics();
            this.getMonthAlarmRankList();
          });
          // let personRecordQueue = `/amq/queue/person_record_queue`

          // this.stompClient.send('/exchange/car_out_record', headers, JSON.stringify({sender: '666',chatType: '777'}))
        },
        err => {
          // console.log(err)
          this.disconnect();
          this.connection();
        }
      );
    },
    // 断开连接
    disconnect() {
      if (this.stompClient != null) {
        this.stompClient.disconnect();
        console.log("Disconnected");
      }
    },
    initWebSocket() {
      this.connection();
      let self = this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(() => {
        try {
          // self.stompClient.send("test");
        } catch (err) {
          console.log("断线了: " + err);
          self.connection();
        }
      }, 5000);
    },

    // 设备点位设置
    showDeviceConfig(deviceValue) {
      this.currentDeviceChooseItem = deviceValue;
      this.currentDeviceNeverConfigList = [];
      this.currentDeviceAlreadyConfigList = [];
      this.deviceManageConfigDialogVisible = true;
    }
  },

  beforeDestroy() {
    this.disconnect();
  },

  watch: {
    currentNav(val) {
      if (this.currentNav === "1") {
        this.getParkBaseInfo();
        this.getStatisticData();
        this.getHonorPage();
        this.getStartEnterprise()
        this.getOutputValueChartData();
      } else if (this.currentNav === "2") {
        this.getFiveYearsEnterprisesCharData();
        this.getEnterpriseCategoryChartData();
        this.getEnterpriseHatchData();
      } else if (this.currentNav === "3") {
        this.getPropertyWorkOrderChartData();
        this.getInspectionChartData();
        this.getInvoiceChartData();
        this.getValueAddedChartData();
        this.getMessageData();
      }
    },

    currentNav2(val) {
      if (this.currentNav2 === "4-1") {
        this.getEquipmentOperationStatusChartData();
      } else if (this.currentNav2 === "4-2") {
        this.getAccessControlChartData();
      } else if (this.currentNav2 === "4-3") {
        this.getTrafficVolumeChartData();
      } else if (this.currentNav2 === "4-4") {
        this.getEngeryConsumptionData();
      } else if (this.currentNav2 === "4-5") {
        this.getFscAlarmOverviewData();
      }
    }
  }
};
</script>

<style scoped lang="less">
.park-display-screen {
  min-width: 1200px;
  min-height: 100%;
  width: 1600px;
  height: 900px;
  flex: 1;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  overflow: auto;
  background: url("../../../assets/upper/upper_bg.png") no-repeat;
  background-size: 100% 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  .portrait-of-enterprises-bg-img-out-box {
    width: 100%;
    height: 100%;
    //flex: 1;
    margin: 0 auto;
    position: relative;
    //box-shadow: 0 0 10px 10px rgba(9, 23, 32, .7);
  }
  .portrait-of-enterprises-bg-img-out-box:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    //box-shadow: 300px 150px 100px rgba(9, 23, 32, 1) inset;
  }
  .portrait-of-enterprises-bg-img-box {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    //transform: translateY(-50%);
    .portrait-of-enterprises-bg-img {
      width: 1138px;
      height: 840px;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
      margin: 0 auto;
    }
    .portrait-of-enterprises-bg-img:after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      //box-shadow: 0 0 3.6rem 3.6rem rgba(9, 23, 32, 1) inset;
    }
  }
  .portrait-of-enterprises-bg-img-box:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url("../../../assets/upper/upper_bg_top.png") no-repeat;
    background-size: 100% 100%;
    //box-shadow: -300px -150px 100px rgba(9, 23, 32, 1) inset;
  }
  .park-display-screen-svg-box {
    width: 100%;
    min-width: 1580px;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    //transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    z-index: 99;
    .park-display-screen-svg-box-svg-main {
      width: 1580px;
      height: 756px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      transform: translateY(-50%);
    }
    path {
      opacity: 0;
      cursor: pointer;
    }
    path:hover {
      opacity: 0.8;
    }
    .point-item {
      z-index: 999;
      i {
        cursor: pointer;
      }
      .el-icon-damai-dingweiweizhi {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 38px;
        color: #32cc32;
      }
      .video-tip-item {
        width: 350px;
        height: 300px;
        position: absolute;
        top: 0;
        left: 16px;
        padding: 5px 25px 10px;
        background: url("../../../assets/basic/top_frame.png") no-repeat;
        background-size: 100% 100%;
        z-index: 99999;
        .video-tip-item-close-line {
          display: flex;
          justify-content: flex-end;
          i {
            color: #eeeeee;
          }
        }
        .video-tip-item-iframe {
          width: 300px;
          height: 225px;
          border-radius: 5px;
          overflow: hidden;
        }
        .video-tip-item-bottom {
          flex: 1;
          margin-top: 10px;
          .video-tip-item-bottom-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .video-tip-item-bottom-line-info {
              color: #ffffff;
            }
          }
          .video-tip-item-bottom-no-tip {
            color: #aaaaaa;
          }
        }
      }

      .pulse,
      .pulse-big {
        position: absolute;
        left: -11px;
        top: -15px;
        width: 60px;
        height: 60px;
        border: 2px solid #ff0000;
        background: rgba(255, 0, 0, 1);
        border-radius: 50%;
        z-index: 100;
        opacity: 0;
        cursor: pointer;
      }
      .pulse {
        background: rgba(255, 0, 0, 1) !important;
        -webkit-animation: warn 0.9s ease-out;
        -moz-animation: warn 0.9s ease-out;
        animation: warn 0.9s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ff0000;
      }
      .pulse-big {
        background: rgba(255, 0, 0, 1) !important;
        -webkit-animation: warn1 0.9s ease-out;
        -moz-animation: warn1 0.9s ease-out;
        animation: warn1 0.9s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ff0000;
      }
    }

    .park-display-screen-top {
      width: 100%;
      height: 103.3px;
      padding: 53.3px 0 0 0;
      margin-bottom: 23px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: #ffffff;
      background: url("../../../assets/upper/enterprise_name_bg.png") no-repeat;
      background-size: 100% 88px;
      //background-position: bottom;
      z-index: 100;
      overflow: hidden;
      font-family: PingFangSC-Medium, PingFang SC;
      position: relative;
      .park-display-screen-top-time {
        position: absolute;
        top: 10px;
        left: 30px;
        z-index: 101;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
      }
      .park-display-screen-top-model {
        position: absolute;
        top: 7px;
        right: 28px;
        z-index: 101;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        /deep/ .el-radio-button__inner {
          padding: 5px 12px;
          border: 1px solid #075C97;
          background: #074F7B;
        }
      }
      .park-display-screen-top-enterprise-name {
        width: 404px;
        height: 42px;
        font-size: 30px;
        font-weight: 500;
        line-height: 42px;
        position: relative;
        top: -47.3px;
      }
      .park-display-screen-top-nav-left-position {
        width: 137px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_left_supplement.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .park-display-screen-top-nav-left-relative {
        position: relative;
        right: -20px;
      }
      .park-display-screen-top-nav-left {
        cursor: pointer;
        width: 251px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_left.png") no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-top-nav-left-current {
        cursor: pointer;
        width: 251px;
        height: 50px;
        font-weight: 500;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_left_current.png")
          no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-top-nav-position {
        position: absolute;
        bottom: 0;
        right: -120px;
      }
      .park-display-screen-top-nav-relative {
        position: relative;
        left: -20px;
      }
      .park-display-screen-top-nav {
        cursor: pointer;
        width: 251px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title.png") no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-top-nav-current {
        cursor: pointer;
        width: 251px;
        height: 50px;
        font-weight: 500;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_current.png") no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-top-nav-position {
        width: 137px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_right_supplement.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .park-display-screen-svg-box-main {
      flex: 1;
      // height: 90%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      position: relative;
      .portrait-of-enterprises-bg-3d-iframe-box {
        width: 894px;
        height: 576px;
        transition: ease-in-out 0.2s;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 120px;
        margin: 0 auto;
        z-index: 50;
        .portrait-of-enterprises-bg-3d-iframe {
          width: 100%;
          height: 100%;
        }
        .portrait-of-enterprises-bg-3d-iframe-img {
          width: 40px;
          height: 40px;
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 51;
          cursor: pointer;
        }
      }
      .portrait-of-enterprises-bg-3d-iframe-box2 {
        width: 100%;
        height: 100%;
        transition: ease-in-out 0.2s;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 9999999;
        .portrait-of-enterprises-bg-3d-iframe {
          width: 100%;
          height: 100%;
        }
        .portrait-of-enterprises-bg-3d-iframe-img {
          width: 40px;
          height: 40px;
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 51;
          cursor: pointer;
        }
      }
      .portrait-of-enterprises-center-top {
        width: 894px;
        height: 72px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 90;
        background: url("../../../assets/upper/page_center_top.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .portrait-of-enterprises-center-top-shadow {
          width: 79px;
          height: 12px;
          position: absolute;
          bottom: -6px;
          left: 815px;
          animation: pageCenterTopShadow 20s linear infinite;
        }
        @keyframes pageCenterTopShadow {
          0% {left: 815px;opacity: 0;}
          10% {left: 652px;opacity: 1;}
          40% {left: 163px;opacity: 1;}
          50% {left: 0;opacity: 0;}
          100% {left: 815px;opacity: 0;}
        }
        .portrait-of-enterprises-center-top-left-decorate {
          width: 42px;
          height: 8px;
          background: url("../../../assets/upper/page_center_top_left_decorate.png") no-repeat;
          background-size: 100% 100%;
          margin-left: 13px;
        }
        .portrait-of-enterprises-center-top-decorate-tip {
          width: 96px;
          height: 37px;
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 37px;
          margin: 0 5px;
        }
        .portrait-of-enterprises-center-top-right-decorate {
          width: 42px;
          height: 8px;
          background: url("../../../assets/upper/page_center_top_right_decorate.png") no-repeat;
          background-size: 100% 100%;
          margin-right: 28px;
        }
        .portrait-of-enterprises-center-top-data-statistics-item {
          width: 96px;
          height: 48px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          .portrait-of-enterprises-center-top-data-statistics-item-name {
            height: 21px;
            font-size: 15px;
            font-weight: 500;
            color: #11FDF2;
            line-height: 21px;
          }
          .portrait-of-enterprises-center-top-data-statistics-item-num {
            height: 24px;
            font-size: 20px;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 24px;
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            .portrait-of-enterprises-center-top-data-statistics-item-num-info {
              font-family: Helvetica-BoldOblique, Helvetica;
              transform: skew(-10deg);
              -webkit-transform: skew(-10deg); /* for Chrome||Safari */
              -ms-transform: skew(-10deg); /* for IE */
              -moz-transform:skew(-10deg);/* for Firefox */
              -o-transform:skew(-10deg);/* for Opera */
            }
            .portrait-of-enterprises-center-top-data-statistics-item-dynamic-box {
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              margin-left: 7px;
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-1 {
                width: 3px;
                height: 5px;
                background: #F6D85D;
                margin-right: 3px;
                animation: dynamic1 1s linear infinite alternate;
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-2 {
                width: 3px;
                height: 8px;
                background: #F5AD59;
                margin-right: 3px;
                animation: dynamic2 1s linear infinite alternate;
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-3 {
                width: 3px;
                height: 11px;
                background: #F58956;
                margin-right: 3px;
                animation: dynamic3 1s linear infinite alternate;
              }
              @keyframes dynamic1 {
                0% {height: 5px;}
                50% {height: 14px;}
                100% {height: 5px;}
              }
              @keyframes dynamic2 {
                0% {height: 9.8px;}
                50% {height: 5px;}
                100% {height: 9.8px;}
              }
              @keyframes dynamic3 {
                0% {height: 14px;}
                50% {height: 9.8px;}
                100% {height: 14px;}
              }
            }
          }
        }
      }
      .portrait-of-enterprises-center-bottom-line, .portrait-of-enterprises-center-bottom-line2, .portrait-of-enterprises-center-bottom-line3 {
        width: 894px;
        height: 106px;
        position: absolute;
        bottom: 8px;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 90;
        background: url("../../../assets/upper/page_bottom_bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .portrait-of-enterprises-center-bottom-line-top-img {
          width: 230px;
          height: 34px;
          position: absolute;
          top: -17px;
          left: 0;
          animation: pageCenterBottomShadow 15s linear infinite;
        }
        @keyframes pageCenterBottomShadow {
          0% {left: 0;opacity: 0;}
          13% {left: 132.8px;opacity: 1;}
          53% {left: 531.2px;opacity: 1;}
          67% {left: 664px;opacity: 0;}
          100% {left: 0;opacity: 0;}
        }
        .portrait-of-enterprises-center-bottom-line-item {
          width: 223.5px;
          height: 106px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #cfac6c;
          text-align: center;
          .portrait-of-enterprises-center-bottom-line-item-tip {
            font-size: 16px;
            font-weight: 500;
            color: #11FDF2;
            line-height: 28px;
          }
          .portrait-of-enterprises-center-bottom-line-item-num {
            height: 47px;
            font-size: 28px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 47px;
          }
          .portrait-of-enterprises-center-bottom-line-item-unit {
            font-size: 28px;
          }
        }
      }

      .portrait-of-enterprises-center-bottom-line2 {
        background: url("../../../assets/upper/page_bottom_bg2.png") no-repeat;
        background-size: 100% 100%;
      }

      .portrait-of-enterprises-center-bottom-line3 {
        background: url("../../../assets/upper/page_bottom_bg3.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-center-bottom-line-item {
          width: 50%;
        }
      }

      .portrait-of-enterprises-left-item-device-config {
        width: 200px;
        height: 150px;
        position: absolute;
        top: 0;
        left: -110px;
        z-index: 66;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        /deep/ .el-radio {
          color: #eeeeee;
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: #cfac6c;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          background: #cfac6c;
          border-color: #cfac6c;
        }
        .portrait-of-enterprises-left-item-device-config-fold-btn {
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          background: linear-gradient(#cfac6c99, #cfac6c66);
        }
        .portrait-of-enterprises-left-item-device-config-main {
          flex: 1;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          padding: 10px;
          background: linear-gradient(#cfac6c66, #cfac6c11);
          .portrait-of-enterprises-left-item-device-config-main-item {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .el-icon-damai-shezhi {
            cursor: pointer;
          }
        }
      }

      .portrait-of-enterprises-left {
        width: 329px;
        height: 99%;
        display: flex;
        justify-content: flex-start;
        z-index: 90;
        background-image: linear-gradient(
          to left,
          rgba(9, 23, 32, 0),
          rgba(9, 23, 32, 1)
        );
        .portrait-of-enterprises-right-strip {
          width: 75%;
          height: 100%;
          margin-left: 10%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          .portrait-of-enterprises-left-nav {
            width: 300px;
            height: 535px;
            padding: 19px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow 20s linear infinite;
            }
            @keyframes pageLeftShadow {
              0% {top: 0;opacity: 0;}
              10% {top: 70.8px;opacity: 1;}
              40% {top: 283.2px;opacity: 1;}
              50% {top: 354px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 263px;
              height: 89px;
              padding: 7px 0;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line {
                flex: 1;
                padding: 0 12px 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .portrait-of-enterprises-left-item-line-top {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-tip {
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #12f1e8;
                  }
                  .portrait-of-enterprises-left-item-line-left-img {
                    width: 43px;
                    height: 13px;
                    margin-left: 5px;
                  }
                }
                .portrait-of-enterprises-left-item-line-info {
                  //font-family: "UnidreamLED";
                  padding-top: 14px;
                  font-size: 42px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-end;
                  .portrait-of-enterprises-left-item-line-info-unit {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-left: 10px;
                  }
                  @media screen and (prefers-color-scheme: dark) {
                    body {
                      color: #59f6fb;
                      background-color: #1c1b1e;
                    }
                  }
                  .digital {
                    position: relative;
                    width: 20.8px;
                    height: 36.8px;
                    margin-left: 5px;
                    background: url("../../../assets/upper/num_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .digital span {
                    position: absolute;
                    box-sizing: border-box;
                  }
                  .digital .c1,
                  .digital .c2,
                  .digital .c3 {
                    height: 0;
                    width: 20.8px;
                    border-left: 3.2px solid transparent;
                    border-right: 3.2px solid transparent;
                  }
                  .digital .c1 {
                    top: 0;
                    left: 0;
                    border-top: 3.2px solid currentColor;
                  }
                  .digital .c2 {
                    top: 50%;
                    left: 0;
                    margin-top: -2px;
                  }
                  .digital .c2:before,
                  .digital .c2:after {
                    content: "";
                    height: 0;
                    width: 19.2px;
                    border-left: 1.6px solid transparent;
                    border-right: 1.6px solid transparent;
                    box-sizing: border-box;
                  }
                  .digital .c2:before {
                    position: absolute;
                    top: 0;
                    left: -2.4px;
                    border-bottom: 1.6px solid currentColor;
                  }
                  .digital .c2:after {
                    position: absolute;
                    top: 1.6px;
                    left: -2.4px;
                    border-top: 1.6px solid currentColor;
                  }
                  .digital_point .point {
                    left: 0;
                    bottom: 0;
                    width: 6.4px;
                    height: 6.4px;
                    border-radius: 50%;
                    background: currentColor;
                  }
                  .digital .c3 {
                    bottom: 0;
                    left: 0;
                    border-bottom: 4px solid currentColor;
                  }
                  .digital .l1,
                  .digital .l2 {
                    height: 16.8px;
                    width: 0;
                    left: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-left: 3.2px solid currentColor;
                  }
                  .digital .l1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .l2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }
                  .digital .r1,
                  .digital .r2 {
                    height: 16.8px;
                    width: 0;
                    right: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-right: 3.2px solid currentColor;
                  }
                  .digital .r1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .r2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }

                  .digital_1 .c1,
                  .digital_1 .c2,
                  .digital_1 .c3,
                  .digital_1 .l1,
                  .digital_1 .l2,
                  .digital_2 .l1,
                  .digital_2 .r2,
                  .digital_3 .l1,
                  .digital_3 .l2,
                  .digital_4 .c1,
                  .digital_4 .c3,
                  .digital_4 .l2,
                  .digital_5 .l2,
                  .digital_5 .r1,
                  .digital_6 .r1,
                  .digital_7 .c2,
                  .digital_7 .c3,
                  .digital_7 .l1,
                  .digital_7 .l2,
                  .digital_9 .l2,
                  .digital_0 .c2,
                  .digital_point .c1,
                  .digital_point .c2,
                  .digital_point .c3,
                  .digital_point .l1,
                  .digital_point .l2,
                  .digital_point .r1,
                  .digital_point .r2{
                    animation: changeDigital 200ms 0ms 1 ease-in forwards;
                  }

                  @keyframes changeDigital {
                    form {
                      opacity: 1;
                    }
                    to {
                      opacity: 0;
                    }
                  }

                  .clock {
                    display: flex;
                    justify-content: center;
                  }
                }
                @font-face {
                  font-family: "UnidreamLED";
                  src: url("../../../assets/font/UnidreamLED.eot");
                  src: url("../../../assets/font/UnidreamLED.eot?#iefix")
                      format("embedded-opentype"),
                    /***兼容ie6-ie8***/
                      url("../../../assets/font/UnidreamLED.woff")
                      format("woff"),
                    local("UnidreamLED"),
                    url("../../../assets/font/UnidreamLED.woff"); /***默认使用本地的***/
                }
              }
            }
          }
          .portrait-of-enterprises-left-nav2 {
            width: 300px;
            height: 610px;
            padding: 30px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left2.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow2 20s linear infinite;
            }
            @keyframes pageLeftShadow2 {
              0% {top: 0;opacity: 0;}
              10% {top: 80.7px;opacity: 1;}
              40% {top: 322.9px;opacity: 1;}
              50% {top: 403.6px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 263px;
              height: 100px;
              padding: 7px 0;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line {
                flex: 1;
                padding: 0 12px 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .portrait-of-enterprises-left-item-line-top {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-tip {
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #12f1e8;
                  }
                  .portrait-of-enterprises-left-item-line-left-img {
                    width: 43px;
                    height: 13px;
                    margin-left: 5px;
                  }
                }
                .portrait-of-enterprises-left-item-line-info {
                  //font-family: "UnidreamLED";
                  padding-top: 28px;
                  font-size: 42px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-end;
                  .portrait-of-enterprises-left-item-line-info-unit {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-left: 10px;
                  }
                  @media screen and (prefers-color-scheme: dark) {
                    body {
                      color: #59f6fb;
                      background-color: #1c1b1e;
                    }
                  }
                  .digital {
                    position: relative;
                    width: 20.8px;
                    height: 36.8px;
                    margin-left: 5px;
                    background: url("../../../assets/upper/num_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .digital span {
                    position: absolute;
                    box-sizing: border-box;
                  }
                  .digital .c1,
                  .digital .c2,
                  .digital .c3 {
                    height: 0;
                    width: 20.8px;
                    border-left: 3.2px solid transparent;
                    border-right: 3.2px solid transparent;
                  }
                  .digital .c1 {
                    top: 0;
                    left: 0;
                    border-top: 3.2px solid currentColor;
                  }
                  .digital .c2 {
                    top: 50%;
                    left: 0;
                    margin-top: -2px;
                  }
                  .digital .c2:before,
                  .digital .c2:after {
                    content: "";
                    height: 0;
                    width: 19.2px;
                    border-left: 1.6px solid transparent;
                    border-right: 1.6px solid transparent;
                    box-sizing: border-box;
                  }
                  .digital .c2:before {
                    position: absolute;
                    top: 0;
                    left: -2.4px;
                    border-bottom: 1.6px solid currentColor;
                  }
                  .digital .c2:after {
                    position: absolute;
                    top: 1.6px;
                    left: -2.4px;
                    border-top: 1.6px solid currentColor;
                  }
                  .digital_point .point {
                    left: 0;
                    bottom: 0;
                    width: 6.4px;
                    height: 6.4px;
                    border-radius: 50%;
                    background: currentColor;
                  }
                  .digital .c3 {
                    bottom: 0;
                    left: 0;
                    border-bottom: 4px solid currentColor;
                  }
                  .digital .l1,
                  .digital .l2 {
                    height: 16.8px;
                    width: 0;
                    left: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-left: 3.2px solid currentColor;
                  }
                  .digital .l1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .l2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }
                  .digital .r1,
                  .digital .r2 {
                    height: 16.8px;
                    width: 0;
                    right: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-right: 3.2px solid currentColor;
                  }
                  .digital .r1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .r2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }

                  .digital_1 .c1,
                  .digital_1 .c2,
                  .digital_1 .c3,
                  .digital_1 .l1,
                  .digital_1 .l2,
                  .digital_2 .l1,
                  .digital_2 .r2,
                  .digital_3 .l1,
                  .digital_3 .l2,
                  .digital_4 .c1,
                  .digital_4 .c3,
                  .digital_4 .l2,
                  .digital_5 .l2,
                  .digital_5 .r1,
                  .digital_6 .r1,
                  .digital_7 .c2,
                  .digital_7 .c3,
                  .digital_7 .l1,
                  .digital_7 .l2,
                  .digital_9 .l2,
                  .digital_0 .c2,
                  .digital_point .c1,
                  .digital_point .c2,
                  .digital_point .c3,
                  .digital_point .l1,
                  .digital_point .l2,
                  .digital_point .r1,
                  .digital_point .r2{
                    animation: changeDigital 200ms 0ms 1 ease-in forwards;
                  }

                  @keyframes changeDigital {
                    form {
                      opacity: 1;
                    }
                    to {
                      opacity: 0;
                    }
                  }

                  .clock {
                    display: flex;
                    justify-content: center;
                  }
                }
                @font-face {
                  font-family: "UnidreamLED";
                  src: url("../../../assets/font/UnidreamLED.eot");
                  src: url("../../../assets/font/UnidreamLED.eot?#iefix")
                  format("embedded-opentype"),
                    /***兼容ie6-ie8***/
                  url("../../../assets/font/UnidreamLED.woff")
                  format("woff"),
                  local("UnidreamLED"),
                  url("../../../assets/font/UnidreamLED.woff"); /***默认使用本地的***/
                }
              }
            }
          }
          .portrait-of-enterprises-left-nav3 {
            width: 300px;
            height: 610px;
            //padding: 30px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left_3.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow2 20s linear infinite;
            }
            @keyframes pageLeftShadow2 {
              0% {top: 0;opacity: 0;}
              10% {top: 80.7px;opacity: 1;}
              40% {top: 322.9px;opacity: 1;}
              50% {top: 403.6px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 230px;
              height: 25%;
              padding: 7px 0;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              font-family: PingFangSC-Regular, PingFang SC;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line, .portrait-of-enterprises-left-item-line-current {
                width: 222px;
                height: 88px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background: url("../../../assets/upper/page_left_3_nav.png") no-repeat;
                background-size: 100% 100%;
                position: relative;
                //.portrait-of-enterprises-left-item-line-embellish {
                //  width: 161px;
                //  height: 7px;
                //  position: absolute;
                //  right: 0;
                //  bottom: 20px;
                //}
                .portrait-of-enterprises-left-item-line-left-img-out-box {
                  width: 88px;
                  height: 88px;
                  margin: 0 8px 0 9px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-left-img-4-1 {
                    width: 35px;
                    height: 26px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-2 {
                    width: 31px;
                    height: 31px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-3 {
                    width: 33px;
                    height: 23px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-4 {
                    width: 26px;
                    height: 26px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-5 {
                    width: 26px;
                    height: 31px;
                  }
                }
                .portrait-of-enterprises-left-item-line-tip {
                  flex: 1;
                  height: 24px;
                  font-size: 17px;
                  font-weight: 500;
                  color: #FFFFFF;
                  line-height: 24px;
                  text-align: left;
                }
              }
              .portrait-of-enterprises-left-item-line-current {
                background: url("../../../assets/upper/page_left_3_nav_current.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .portrait-of-enterprises-left-card {
            width: 300px;
            height: 190px;
            background: url("../../../assets/upper/page_left_bottom.png")
              no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .portrait-of-enterprises-left-card-img {
              width: 220px;
              height: 124px;
            }
          }
          /deep/ .el-carousel__button {
            width: 20px;
          }
        }
      }
      .portrait-of-enterprises-center {
        height: 99%;
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        position: relative;

        .portrait-of-enterprises-center-top {
          width: 894px;
          height: 72px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          z-index: 88;
          background: url("../../../assets/upper/page_center_top.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-center-top-shadow {
            width: 79px;
            height: 12px;
            position: absolute;
            bottom: -6px;
            left: 815px;
            animation: pageCenterTopShadow 20s linear infinite;
          }
          @keyframes pageCenterTopShadow {
            0% {left: 815px;opacity: 0;}
            10% {left: 652px;opacity: 1;}
            40% {left: 163px;opacity: 1;}
            50% {left: 0;opacity: 0;}
            100% {left: 815px;opacity: 0;}
          }
          .portrait-of-enterprises-center-top-left-decorate {
            width: 42px;
            height: 8px;
            background: url("../../../assets/upper/page_center_top_left_decorate.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 13px;
          }
          .portrait-of-enterprises-center-top-decorate-tip {
            width: 96px;
            height: 37px;
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 37px;
            margin: 0 5px;
          }
          .portrait-of-enterprises-center-top-right-decorate {
            width: 42px;
            height: 8px;
            background: url("../../../assets/upper/page_center_top_right_decorate.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 28px;
          }
          .portrait-of-enterprises-center-top-data-statistics-item {
            width: 96px;
            height: 48px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            .portrait-of-enterprises-center-top-data-statistics-item-name {
              height: 21px;
              font-size: 15px;
              font-weight: 500;
              color: #11FDF2;
              line-height: 21px;
            }
            .portrait-of-enterprises-center-top-data-statistics-item-num {
              height: 24px;
              font-size: 20px;
              font-weight: normal;
              color: #FFFFFF;
              line-height: 24px;
              display: flex;
              justify-content: flex-start;
              align-items: baseline;
              .portrait-of-enterprises-center-top-data-statistics-item-num-info {
                font-family: Helvetica-BoldOblique, Helvetica;
                transform: skew(-10deg);
                -webkit-transform: skew(-10deg); /* for Chrome||Safari */
                -ms-transform: skew(-10deg); /* for IE */
                -moz-transform:skew(-10deg);/* for Firefox */
                -o-transform:skew(-10deg);/* for Opera */
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-box {
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                margin-left: 7px;
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-1 {
                  width: 3px;
                  height: 5px;
                  background: #F6D85D;
                  margin-right: 3px;
                  animation: dynamic1 1s linear infinite alternate;
                }
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-2 {
                  width: 3px;
                  height: 8px;
                  background: #F5AD59;
                  margin-right: 3px;
                  animation: dynamic2 1s linear infinite alternate;
                }
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-3 {
                  width: 3px;
                  height: 11px;
                  background: #F58956;
                  margin-right: 3px;
                  animation: dynamic3 1s linear infinite alternate;
                }
                @keyframes dynamic1 {
                  0% {height: 5px;}
                  50% {height: 14px;}
                  100% {height: 5px;}
                }
                @keyframes dynamic2 {
                  0% {height: 9.8px;}
                  50% {height: 5px;}
                  100% {height: 9.8px;}
                }
                @keyframes dynamic3 {
                  0% {height: 14px;}
                  50% {height: 9.8px;}
                  100% {height: 14px;}
                }
              }
            }
          }
        }
        .portrait-of-enterprises-center-bottom-line, .portrait-of-enterprises-center-bottom-line2, .portrait-of-enterprises-center-bottom-line3 {
          width: 894px;
          height: 106px;
          background: url("../../../assets/upper/page_bottom_bg.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .portrait-of-enterprises-center-bottom-line-top-img {
            width: 230px;
            height: 34px;
            position: absolute;
            top: -17px;
            left: 0;
            animation: pageCenterBottomShadow 15s linear infinite;
          }
          @keyframes pageCenterBottomShadow {
            0% {left: 0;opacity: 0;}
            13% {left: 132.8px;opacity: 1;}
            53% {left: 531.2px;opacity: 1;}
            67% {left: 664px;opacity: 0;}
            100% {left: 0;opacity: 0;}
          }
          .portrait-of-enterprises-center-bottom-line-item {
            width: 223.5px;
            height: 106px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: #cfac6c;
            text-align: center;
            .portrait-of-enterprises-center-bottom-line-item-tip {
              font-size: 16px;
              font-weight: 500;
              color: #11FDF2;
              line-height: 28px;
            }
            .portrait-of-enterprises-center-bottom-line-item-num {
              height: 47px;
              font-size: 28px;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 47px;
            }
            .portrait-of-enterprises-center-bottom-line-item-unit {
              font-size: 28px;
            }
          }
        }

        .portrait-of-enterprises-center-bottom-line2 {
          background: url("../../../assets/upper/page_bottom_bg2.png") no-repeat;
          background-size: 100% 100%;
        }

        .portrait-of-enterprises-center-bottom-line3 {
          background: url("../../../assets/upper/page_bottom_bg3.png") no-repeat;
          background-size: 100% 100%;
          .portrait-of-enterprises-center-bottom-line-item {
            width: 50%;
          }
        }

        .portrait-of-enterprises-left-item-device-config {
          width: 200px;
          height: 150px;
          position: absolute;
          top: 0;
          left: -110px;
          z-index: 66;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          /deep/ .el-radio {
            color: #eeeeee;
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: #cfac6c;
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            background: #cfac6c;
            border-color: #cfac6c;
          }
          .portrait-of-enterprises-left-item-device-config-fold-btn {
            height: 24px;
            line-height: 24px;
            cursor: pointer;
            background: linear-gradient(#cfac6c99, #cfac6c66);
          }
          .portrait-of-enterprises-left-item-device-config-main {
            flex: 1;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            padding: 10px;
            background: linear-gradient(#cfac6c66, #cfac6c11);
            .portrait-of-enterprises-left-item-device-config-main-item {
              padding: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .el-icon-damai-shezhi {
              cursor: pointer;
            }
          }
        }
      }
      .portrait-of-enterprises-right {
        width: 333.67px;
        height: 99%;
        display: flex;
        justify-content: flex-start;
        z-index: 90;
        background-image: linear-gradient(
          to right,
          rgba(9, 23, 32, 0),
          rgba(9, 23, 32, 1)
        );
        .portrait-of-enterprises-right-strip {
          height: 100%;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .portrait-of-enterprises-item-liquid-fill-top-line {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            .portrait-of-enterprises-item-liquid-fill-top-line-item {
              width: 48%;
              height: 20px;
              padding: 0 9px;
              margin-bottom: 3px;
              text-align: left;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: url("../../../assets/upper/inspection_title_bg.png") no-repeat;
              background-size: 100% 100%;
              .portrait-of-enterprises-item-liquid-fill-top-line-item-num {
                flex: 1;
                text-align: right;
                font-size: 12px;
                font-weight: bold;
              }
              .portrait-of-enterprises-item-liquid-fill-top-line-item-tip {
                font-size: 12px;
              }
            }
          }
          .portrait-of-enterprises-item-liquid-fill-line {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            .portrait-of-enterprises-item-liquid-fill-item {
              width: 70px;
              height: 100%;
              display: flex;
              justify-content: flex-end;
              flex-direction: column;
              .portrait-of-enterprises-item-liquid-fill {
                width: 60px;
                height: 60px;
                margin: 0 auto;
                background: url("../../../assets/upper/inspection_chart_bg.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .portrait-of-enterprises-item-equipment-operation-box {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 4px 6px 10px;
            padding: 0 13px 0 18px;
            background: url("../../../assets/upper/equipment_operation_bg.png") no-repeat;
            background-size: 100% 100%;
          }
          .portrait-of-enterprises-item-equipment-operation-ring-box {
            background: url("../../../assets/upper/device_ring_bg.png") no-repeat;
            background-size: 100% auto;
            background-position: center center;
          }
          .portrait-of-enterprises-item-equipment-operation-status-box {
            flex: 1;
            padding: 5px 10px;
            .portrait-of-enterprises-item-equipment-operation-status-box-item {
              height: 50%;
              padding: 5px 0;
              text-align: right;
              .portrait-of-enterprises-item-equipment-operation-status-box-item-name {
                width: fit-content;
                margin-bottom: 8px;
                padding: 3px 7px;
                background: url("../../../assets/upper/device_ring_name_bg.png") no-repeat;
                background-size: 100% 100%;
              }
              .portrait-of-enterprises-item-equipment-operation-status-box-item-num {
                font-size: 18px;
                height: 22px;
                line-height: 22px;
                padding: 0 13px 0 6px;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .portrait-of-enterprises-item-equipment-operation-status-box-item-num-info {
                  font-weight: 600;
                  color: #FFFFFF;
                  flex: 1;
                  text-align: center;
                }
                .portrait-of-enterprises-item-equipment-operation-status-box-item-unit {
                  font-size: 12px;
                  font-weight: 500;
                  color: #0DCCFD;
                }
              }
            }
          }

          .portrait-of-enterprises-item-device-statistics-table {
            width: 100%;
            padding: 10px 10px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            .portrait-of-enterprises-item-device-statistics-table-line {
              width: 100%;
              .portrait-of-enterprises-item-device-statistics-table-line-name-line {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 3px;
                .portrait-of-enterprises-item-device-statistics-table-line-name-line-left {
                  font-size: 12px;
                  text-align: center;
                  padding: 2px 10px;
                  background: url("../../../assets/upper/device_proportion_name_bg.png") no-repeat;
                  background-size: 100% 100%;
                }
                .portrait-of-enterprises-item-device-statistics-table-line-name-line-right {
                  .portrait-of-enterprises-item-device-statistics-table-line-name-line-right-info {
                    font-weight: 500;
                    font-family: fantasy;
                    font-size: 16px;
                  }
                }
              }
              .portrait-of-enterprises-item-device-statistics-table-line-info {
                height: 14px;
                line-height: 14px;
                overflow: hidden;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background: url("../../../assets/upper/device_proportion_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-item-device-statistics-table-line-info-left {
                  text-align: right;
                  font-size: 12px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
                }
              }
            }
          }

          .portrait-of-enterprises-right-in-and-out-snapshot {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 0 0;
            background: url("../../../assets/upper/page_right_item_car_division.png") no-repeat;
            background-position: center center;
            background-size: auto 100%;
            .portrait-of-enterprises-right-in-and-out-snapshot-item {
              width: 48%;
              height: 100%;
              padding: 0 0 20px 0;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              align-items: center;
              text-align: center;
              font-family: PingFangSC-Medium, PingFang SC;
              .portrait-of-enterprises-right-in-and-out-snapshot-item-top-title {
                width: 80px;
                height: 14px;
                margin: 0 auto;
                font-size: 10px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 14px;
              }
              .portrait-of-enterprises-right-in-and-out-snapshot-item-img-out-box {
                width: 100px;
                height: 50px;
                margin: 0 auto;
                background: url("../../../assets/upper/page_right_item_car_number_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-right-in-and-out-snapshot-item-img {
                  width: 94px;
                  height: 46px;
                  margin: 3px auto;
                }
              }
              .portrait-of-enterprises-right-in-and-out-snapshot-item-tip {
                width: 80px;
                font-size: 10px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 14px;
                text-align: left;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .portrait-of-enterprises-right-in-and-out-snapshot-item-spot {
                  width: 6px;
                  height: 6px;
                  margin: 4px 4px 4px 0;
                  border-radius: 50%;
                  background: #12FDF0;
                  display: inline-block;
                }
                .portrait-of-enterprises-right-in-and-out-snapshot-item-tip-text {
                  flex: 1;
                }
              }
            }
          }

          .portrait-of-enterprises-item-energy-distribution-box {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .portrait-of-enterprises-item-energy-distribution-ring-box {
              background: url("../../../assets/upper/device_ring_bg.png") no-repeat;
              background-size: 100% auto;
              background-position: center center;
            }
          }

          .portrait-of-enterprises-item-energy-ranking-line {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0 10px;
            margin-bottom: 8px;
            .portrait-of-enterprises-item-energy-ranking-line-icon-1, .portrait-of-enterprises-item-energy-ranking-line-icon-2, .portrait-of-enterprises-item-energy-ranking-line-icon-3 {
              width: 26px;
              height: 14px;
              line-height: 14px;
              font-size: 12px;
              font-weight: 500;
              margin: 6px 20px 0 0;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-1 {
              background: url("../../../assets/upper/energy_ranking_1.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-2 {
              background: url("../../../assets/upper/energy_ranking_2.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-3 {
              background: url("../../../assets/upper/energy_ranking_3.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-info {
              flex: 1;
              font-size: 12px;
              .portrait-of-enterprises-item-energy-ranking-line-info-name {
                text-align: left;
                line-height: 14px;
                margin-bottom: 2px;
              }
              .portrait-of-enterprises-item-energy-ranking-line-info-electric {
                height: 10px;
                line-height: 10px;
                text-align: right;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                margin-bottom: 2px;
                .portrait-of-enterprises-item-energy-ranking-line-info-electric-info {
                  white-space: nowrap;
                  height: 12px;
                  font-size: 10px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
                }
              }
              .portrait-of-enterprises-item-energy-ranking-line-info-water {
                height: 10px;
                line-height: 10px;
                text-align: right;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-item-energy-ranking-line-info-water-info {
                  white-space: nowrap;
                  height: 12px;
                  font-size: 10px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #E8E708 0%, rgba(244, 206, 89, 0) 100%);
                }
              }
            }
          }
          .portrait-of-enterprises-item-energy-ranking-line:last-child {
            margin-bottom: 0;
          }
        }
      }

      .portrait-of-enterprises-item, .portrait-of-enterprises-item-2, .portrait-of-enterprises-item-car-1, .portrait-of-enterprises-item-car-2, .portrait-of-enterprises-item-car-3, .portrait-of-enterprises-item-device-top, .portrait-of-enterprises-item-device-type {
        width: 306.67px;
        height: 185.83px;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        background: url("../../../assets/upper/page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-title {
          margin: 5px 0 5px 0;
          color: #ffffff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-item-title-icon {
            width: 32px;
            font-size: 18px;
            padding: 0 0 5px 0;
          }
          .portrait-of-enterprises-item-title-info {
            padding: 0 0 5px 0;
            font-size: 14px;
            margin-left: 5px;
          }
        }
        .portrait-of-enterprises-item-ring-box {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-ring-box-left {
            width: 90px;
            height: 90px;
            background: url("../../../assets/upper/ring_bg.png") no-repeat;
            background-size: 100%;
            background-position-y: center;
          }
          .portrait-of-enterprises-item-ring-box-right {
            height: 116px;
            flex: 1;
            overflow-y: auto;
            .portrait-of-enterprises-item-ring-box-right-line {
              width: 150px;
              height: 22px;
              margin: 0 auto 7px;
              padding: 0 3px 0 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: url("../../../assets/upper/ring_legend_bg.png") no-repeat;
              background-size: 100% 100%;
              .portrait-of-enterprises-item-ring-box-right-line-color {
                width: 9px;
                height: 8px;
              }
              .portrait-of-enterprises-item-ring-box-right-line-name {
                flex: 1;
                font-size: 10px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 13px;
                margin: 0 3px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .portrait-of-enterprises-item-ring-box-right-line-num {
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 15px;
              }
              .portrait-of-enterprises-item-ring-box-right-line-proportion {
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 15px;
              }
            }
          }
        }
        .total-intellectual-property-config-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .total-intellectual-property-config-line-name {
            width: 64px;
            height: 14px;
            padding: 0 4px;
            line-height: 14px;
            font-size: 8px;
            background: url("../../../assets/upper/total_intellectual_name_bg.png") no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .total-intellectual-property-config-line-value {
            flex: 1;
            width: 139px;
            height: 12px;
            margin-left: 6px;
            background: url("../../../assets/upper/total_intellectual_value_bg.png") no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .total-intellectual-property-config-line-value-info {
              color: #000000;
              text-align: right;
              font-weight: 600;
              font-size: 8px;
              line-height: 12px;
              background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
            }
          }
        }
        /deep/ .el-timeline-item__content {
          font-size: 12px;
        }
        /deep/ .el-timeline-item__timestamp {
          font-size: 12px;
        }
        /deep/ .el-timeline-item__tail {
          left: 0;
          top: 12%;
          width: 1px;
          height: 80%;
          background: #0DFDF2;
          border: 0;
        }
        /deep/ .el-timeline-item__node--normal {
          width: 3px;
          height: 3px;
          background: #0DFDF2;
          box-shadow: 0px 0px 3px 0px rgba(125,224,195,0.5);
        }
        /deep/ .active-ring-chart-container canvas {
          width: 100%;
          height: 100%;
        }
        /deep/ .dv-active-ring-chart .active-ring-info .dv-digital-flop {
          width: 70px;
          height: 24px;
        }
        /deep/ .dv-active-ring-chart .active-ring-info .active-ring-name {
          width: 70px;
          white-space: normal;
        }
        /deep/ .dv-capsule-chart .label-column div {
          width: 100px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        /deep/ .dv-scroll-board .header .header-item {
          font-size: 12px;
        }
        /deep/ .dv-scroll-board .rows .row-item {
          font-size: 12px;
          height: 21.6px;
          line-height: 21.6px;
        }
        /deep/ .dv-scroll-board .rows {
          height: 108px;
        }
      }
      .portrait-of-enterprises-item-2 {
        width: 306.67px;
        height: 196px;
        background: url("../../../assets/upper/page_right_item_bg2.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-1 {
        width: 306.67px;
        height: 271.69px;
        background: url("../../../assets/upper/car_page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-2 {
        width: 306.67px;
        height: 235.54px;
        background: url("../../../assets/upper/car_page_right_item_bg_2.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-3 {
        width: 306.67px;
        height: 223.06px;
        background: url("../../../assets/upper/car_page_right_item_bg_3.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-car-top-line {
          width: 100%;
          margin: 9px 0;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-car-top-line-item {
            width: 49%;
            height: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .portrait-of-enterprises-item-car-top-line-item-title {
              font-size: 8px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 11px;
            }
            .portrait-of-enterprises-item-car-top-line-item-num {
              width: auto;
              padding: 0 6px;
              height: 14px;
              line-height: 14px;
              background: #14ABF9;
              background: url("../../../assets/upper/page_right_property_num.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .portrait-of-enterprises-item-device-top {
        width: 306.67px;
        height: 219.05px;
        background: url("../../../assets/upper/page_right_item_device_top.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-device-type {
        width: 306.67px;
        height: 521.61px;
        background: url("../../../assets/upper/page_right_item_device_type.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item2 {
        width: 306.67px;
        height: 185.83px;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        background: url("../../../assets/upper/page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-property-work-order-line {
          width: 100%;
          margin: 9px 0;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-property-work-order-line-item {
            width: 49%;
            height: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .portrait-of-enterprises-item-property-work-order-line-item-title {
              font-size: 9px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 11px;
              margin-right: 6px;
            }
            .portrait-of-enterprises-item-property-work-order-line-item-num {
              width: auto;
              padding: 0 7px;
              height: 14px;
              line-height: 14px;
              background: #14ABF9;
              background: url("../../../assets/upper/page_right_property_num.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .portrait-of-enterprises-item-title {
          color: #FFFFFF;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-item-title-img {
            width: 8px;
            height: 12px;
          }
          .portrait-of-enterprises-item-title-icon {
            width: 32px;
            font-size: 18px;
            padding: 0 0 5px 0;
          }
          .portrait-of-enterprises-item-title-info {
            font-size: 13px;
            margin-left: 5px;
          }
        }

        .device-operation-statistics-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0;
          #deviceOnlineRate {
            width: 100px;
            height: 100px;
          }
          .device-operation-statistics-line-item {
            width: 100px;
            height: 60px;
            padding: 10px;
            .device-operation-statistics-line-item-tip {
              text-align: left;
              line-height: 15px;
              font-size: 12px;
            }
            .device-operation-statistics-line-item-info {
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              text-align: left;
              line-height: 35px;
              .device-operation-statistics-line-item-number {
                font-size: 18px;
              }
              .device-operation-statistics-line-item-unit {
                font-size: 10px;
              }
            }
          }

          .device-operation-statistics-line-info {
            font-family: fantasy;
            font-size: 24px;
          }
          .device-operation-statistics-line-tip {
            font-size: 10px;
          }
          .device-operation-statistics-line-right {
            .device-operation-statistics-line-info {
              color: #fb140f;
            }
          }
        }

        .portrait-of-enterprises-right-strip-device-box {
          width: 100%;
          height: 280px;
          margin-bottom: 20px;
          .portrait-of-enterprises-right-strip-device-no-tip {
            height: 100%;
            padding: 10px 15px;
            text-align: center;
            color: #aaaaaa;
            font-size: 12px;
          }
          .portrait-of-enterprises-right-strip-device-list {
            height: 100%;
            padding: 10px 15px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            overflow-y: auto;
            .portrait-of-enterprises-right-strip-device-item {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              i {
                width: 50px;
                height: 40px;
                line-height: 40px;
                margin: 0 20px 0 0;
                font-size: 24px;
              }
              .portrait-of-enterprises-right-strip-device-item-info {
                flex: 1;
                .portrait-of-enterprises-right-strip-device-item-info-name {
                  font-size: 14px;
                  text-align: left;
                }
                .portrait-of-enterprises-right-strip-device-item-info-number {
                  font-size: 12px;
                  color: #aaaaaa;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
              }
            }
          }
        }

        .device-operation-alar-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0;
          .device-operation-alar-line-item {
            width: 100%;
            height: 60px;
            padding: 10px;
            .device-operation-alar-line-item-info {
              font-family: fantasy;
              font-size: 24px;
            }
            .device-operation-alar-line-item-name {
              font-size: 12px;
            }
          }
        }

        .alarm-record-table {
          height: 100%;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          text-align: center;
          font-size: 12px;
          padding: 10px 5px;
          .alarm-record-table-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #aaaaaa;
            padding: 10px 0;
          }
          .alarm-record-table-main {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            overflow-y: auto;
            .alarm-record-table-main-line {
              margin: 10px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .alarm-record-table-main-no-tip {
              padding: 10px 15px;
              color: #aaaaaa;
            }
          }
        }

        .fireman-box {
          width: 100%;
          flex: 1;
          padding: 10px;
          margin: 10px auto;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .fireman-box-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-icon-damai-xiaofangyuan {
              font-size: 36px;
              background-image: -webkit-linear-gradient(
                bottom,
                red,
                #ff5f60,
                #f0c41b
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            .fireman-box-line-name {
              text-align: left;
              margin-left: 5px;
              flex: 1;
            }
            .fireman-box-line-phone {
            }
          }
        }
      }
    }
  }

  .park-display-screen-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    background-image: linear-gradient(rgba(9, 23, 32, 0), rgba(9, 23, 32, 1));
  }
  .park-display-screen-bottom-basic-line {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 77%;
    padding: 0 10px;
    height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    z-index: 99999;
    .park-display-screen-bottom-basic-line-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 15px;
      .park-display-screen-bottom-basic-line-item-img {
        width: 50px;
        height: 50px;
      }
      .park-display-screen-bottom-basic-line-item-info {
        .park-display-screen-bottom-basic-line-item-amount {
        }
        .park-display-screen-bottom-basic-line-item-name {
          font-size: 12px;
          color: rgb(103, 224, 227);
        }
      }
    }
  }

  /deep/ .el-progress__text {
    color: #ffffff;
  }
  /deep/.el-timeline-item__wrapper {
    text-align: left;
  }
  /deep/.el-timeline-item__content {
    color: #ffffff;
  }
  /deep/.el-timeline-item__timestamp {
    color: #eeeeee;
  }
  /deep/.unit-label {
    display: none;
  }
  /deep/.unit-text {
    display: none;
  }
  /deep/.label-column > div:last-child {
    display: none;
  }

  #portraitEnterprisesItemRing::-webkit-scrollbar ,#parkHonorTimer::-webkit-scrollbar, #totalIntellectualProperty::-webkit-scrollbar {
    display: none;
    width: 0px;
    height: 0px;
  }
  #portraitEnterprisesItemRing .-o-scrollbar, #parkHonorTimer .-o-scrollbar, #totalIntellectualProperty .-o-scrollbar {
    width: 0px;
    height: 0px;
  }
  #portraitEnterprisesItemRing, #parkHonorTimer, #totalIntellectualProperty {
    -ms-scroll-chaining: chained;
    -ms-overflow-style: none;
    -ms-content-zooming: zoom;
    -ms-scroll-rails: none;
    -ms-content-zoom-limit-min: 100%;
    -ms-content-zoom-limit-max: 500%;
    -ms-scroll-snap-type: proximity;
    -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
    -ms-overflow-style: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #f9c986;
    background: #f9c986;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px #a26e26;
    border-radius: 5px;
    background: #a26e26;
  }

  .device-manage-config-dialog-visible {
    .device-manage-config-dialog-visible-main {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .device-manage-config-dialog-visible-left {
        position: relative;
        width: 80%;
        .device-manage-config-dialog-visible-left-img {
          display: block;
          width: 100%;
          height: auto;
        }
        div {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .device-manage-config-dialog-visible-left-canvas {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          /deep/ .canvas-container {
            width: 100%;
            height: 100%;
          }
        }
      }
      .device-manage-config-dialog-visible-right {
        flex: 1;
      }
    }
    /deep/ .el-dialog {
      background: #ffffff99;
    }
    /deep/ .el-dialog__header {
      display: none;
    }
    /deep/ .el-dialog__body {
      padding: 0;
    }
  }
}

@keyframes warn {
  0% {
    -moz-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes warn1 {
  0% {
    -o-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -o-transform: scale(0.6);
    transform: scale(0.6);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/ParkDisplayScreen/ParkDisplayScreen2.vue